<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { cloneDeep, groupBy, sortBy } from "lodash";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import PrintOptions from "@/components/modals/print-options.vue";
import PrLogs from "@/components/modals/pr-logs.vue";
import EmployeeModal from '@/components/modals/employee.vue';
import AttachmentModal from "@/components/modals/attachment-modal.vue";
import DatePicker from "vue2-datepicker";
import ItemCategory from "@/components/modals/item-category.vue";
import Unit from "@/components/modals/unit.vue";
import ConsolidatedItems from "@/components/modals/pr-consolidated-items.vue";
import RawData from "@/components/widgets/raw-data.vue";
import ItemUpdate from "@/router/views/office/office-widgets/update-pr-modal.vue"

export default {
    page: {
        title: "Purchase Requests",
    },
    components: {
        Layout,
        PageHeader,
        MaskedInput,
        PrintOptions,
        PrLogs,
        EmployeeModal,
        AttachmentModal,
        DatePicker,
        ItemCategory,
        Unit,
        ConsolidatedItems,
        RawData,
        ItemUpdate
    },
    data() {
        return {
            title: "My Purchase Requests",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "My Purchase Requests",
                    active: true,
                },
            ],
            singleSelection: true,
            currencyMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: false,
                allowDecimal: true,
            }),
            modalTitle: "",
            availableTable: [],
            availableBusy: false,
            filterItem: "",
            filterCartItems: "",
            filterUpdateItems: "",
            pageOptions: [10, 25, 50, 100],
            perPageItem: 10,
            perPageUpdate: 10,
            currentPageItem: 1,
            currentPageUpdate: 1,
            selectedItems: [],
            monthsNickname: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "June",
                "July",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ],
            cartCount: 0,
            cartItems: [],
            cartVariables: {},
            pr: {
                id: 0,
                description: "",
                endUserName: "",
                endUserId: "",
                deliveryLocation: "",
                deliveryPeriod: "",
            },
            prHeader: {
                id: 0,
                description: "",
                endUserName: "",
                endUserId: "",
                deliveryPeriod: "",
            },
            tabIndex: 0,
            prData: [],
            posted: [],
            submitteds: [],
            approved: [],
            returned: [],
            prBusy: false,
            updateItems: [],
            cartBusy: false,
            updateBusy: false,
            showUpdatePR: false,
            filterReturn: "",
            filterPosted: "",
            filterApproved: "",
            currentPagePR: 1,
            perPagePR: 10,
            pillsIndex: 0,
            selectedApiResource: null,
            editType: "submit",
            attachmentCount: 0,
            filterSubmitted: "",
            selectedPR: null,
            returnedItems: [],
            selectedPRCopy: null,
            selectedReturnPR: "",
            units: [],
            movePrItem: null,
            consolidatedItems: [],
            showConsolidatedItems: false,
            mustLoadAvailableItems: false,
            selectedParentPrItemId: null,
            consolidationType: null,
        };
    },
    watch:{
        $route (to, from){
            if(this.$route.params.id){
                this.refreshData(2);
            }
        }
    },
    async created() {
        this.pageLoader(true);
        await this.getUnits();
        await this.changeCycle(this.$store.state.data.cycle);
        this.pageLoader(false);
    },
    validations: {
        pr: {
            description: { required },
            endUserName: { required },
            deliveryLocation: { required },
            deliveryPeriod: { required },
        },
        prHeader: {
            description: { required },
            endUserName: { required },
            deliveryLocation: { required },
            deliveryPeriod: { required },
        },
        selectedPR: {
            description: { required },
            datePosted: { required },
        }
    },
    computed: {
        filteredAvailableItems() {
            let data = this.availableTable;
            // var total = this.currentPageItem * this.perPageItem;
            if (this.filterItem.trim() != "" && this.filterItem) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterItem.toUpperCase());
                });
            }
            // var currentData = data.slice(total - this.perPageItem, total);
            // if (this.currentPageItem > 1 && currentData.length == 0) {
            //     total = (this.currentPageItem - 1) * this.perPageItem;
            //     currentData = data.slice(total - this.perPageItem, total);
            // }
            return data;
        },
        selectedAvailableItems() {
            let items = [];
            this.availableTable.forEach((a) => {
                a.fundClassifications.map((b) => {
                    b.apis.map(item => {
                        item.availableApiResourceItems.forEach((x) => {
                            x.toggleSelected && items.push(x);
                        });
                    })
                });
                
            });
            return items;
        },
        filteredCartItems() {
            let data = this.cartItems;
            var total = this.currentPageItem * this.perPageItem;
            if (this.filterCartItems.trim() != "" && this.filterCartItems) {
                data = data.filter((item) => {
                    return item.apiResource.itemName
                        .toUpperCase()
                        .includes(this.filterCartItems.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPageItem, total);
            if (this.currentPageItem > 1 && currentData.length == 0) {
                total = (this.currentPageItem - 1) * this.perPageItem;
                currentData = data.slice(total - this.perPageItem, total);
            }
            return currentData;
        },
        rowsCartItems() {
            if (this.filterCartItems.trim() != "" && this.filterCartItems) {
                return this.filteredCartItems.length;
            } else {
                return this.cartItems.length;
            }
        },
        filteredUpdateItems() {
            let data = this.updateItems;
            var total = this.currentPageUpdate * this.perPageUpdate;
            if (this.filterUpdateItems.trim() != "" && this.filterUpdateItems) {
                data = data.filter((item) => {
                    return item.itemName
                        .toUpperCase()
                        .includes(this.filterUpdateItems.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPageUpdate, total);
            if (this.currentPageUpdate > 1 && currentData.length == 0) {
                total = (this.currentPageUpdate - 1) * this.perPageUpdate;
                currentData = data.slice(total - this.perPageUpdate, total);
            }
            return currentData;
        },
        rowsUpdateItems() {
            if (this.filterUpdateItems.trim() != "" && this.filterUpdateItems) {
                return this.filteredUpdateItems.length;
            } else {
                return this.updateItems.length;
            }
        },
        filteredReturn() {
            let data = this.returned;
            var total = this.currentPagePR * this.perPagePR;
            if (this.filterReturn.trim() != "" && this.filterReturn) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterReturn.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPagePR, total);
            if (this.currentPagePR > 1 && currentData.length == 0) {
                total = (this.currentPagePR - 1) * this.perPagePR;
                currentData = data.slice(total - this.perPagePR, total);
            }
            return currentData;
        },
        rowsReturn() {
            if (this.filterReturn.trim() != "" && this.filterReturn) {
                return this.filteredReturn.length;
            } else {
                return this.returned.length;
            }
        },
        filteredPosted() {
            let data = this.posted;
            var total = this.currentPagePR * this.perPagePR;
            if (this.filterPosted.trim() != "" && this.filterPosted) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterPosted.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPagePR, total);
            if (this.currentPagePR > 1 && currentData.length == 0) {
                total = (this.currentPagePR - 1) * this.perPagePR;
                currentData = data.slice(total - this.perPagePR, total);
            }
            return currentData;
        },
        rowsPosted() {
            let data = this.posted;
            if (this.filterPosted.trim() != "" && this.filterPosted) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterPosted.toUpperCase());
                });
            }
            return data.length;
        },
        filteredSubmitted() {
            let data = this.submitteds;
            var total = this.currentPagePR * this.perPagePR;
            if (this.filterSubmitted.trim() != "" && this.filterSubmitted) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterSubmitted.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPagePR, total);
            if (this.currentPagePR > 1 && currentData.length == 0) {
                total = (this.currentPagePR - 1) * this.perPagePR;
                currentData = data.slice(total - this.perPagePR, total);
            }
            return currentData;
        },
        rowsSubmitted() {
            let data = this.submitteds;
            if (this.filterPosted.trim() != "" && this.filterPosted) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterPosted.toUpperCase());
                });
            }
            return data.length;
        },
        filteredApproved() {
            let data = this.approved;
            var total = this.currentPagePR * this.perPagePR;
            if (this.filterApproved.trim() != "" && this.filterApproved) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterApproved.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPagePR, total);
            if (this.currentPagePR > 1 && currentData.length == 0) {
                total = (this.currentPagePR - 1) * this.perPagePR;
                currentData = data.slice(total - this.perPagePR, total);
            }
            return currentData;
        },
        rowsApproved() {
            let data = this.approved;
            if (this.filterPosted.trim() != "" && this.filterPosted) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterPosted.toUpperCase());
                });
            }
            return data.length;
        },
    },
    methods: {
        async getUnits(){
            try{
                const {data} = await this.$store.dispatch("unit/GetUnit")
                this.units = data;
            }catch(err){
                this.showToast("Something went wrong!","error");
            }
        },
        async changeCycle(cycle) {
            this.pageLoader(true);
            await this.getAvailableItems(cycle, this.$store.state.data.selectedDU.id, this.$store.state.data.selectedDepartment.id);
            await this.getCartItems(cycle, this.$store.state.data.selectedDU.id, this.$store.state.data.selectedDepartment.id);
            await this.getAllMyPR(cycle, this.$store.state.data.selectedDU.id, this.$store.state.data.selectedDepartment.id);
            this.pageLoader(false);
        },
        async changeDepartment(departmentId) {
            this.pageLoader(true);
            await this.getAvailableItems(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id, departmentId);
            await this.getCartItems(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id, departmentId);
            await this.getAllMyPR(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id, departmentId);
            // await this.getReturnedPRItems(deliveryUnitId);
            this.pageLoader(false);
        },
        async getReturnedPRItems(id){
            this.returnedItems = [];
            await this.$store
                .dispatch("pritem/GetReturnedPrItems", id)
                .then((res) => {
                    this.returnedItems = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async getAvailableItems(cycle, deliveryUnitId, departmentId) {
            this.availableTable = [];
            this.availableBusy = true;
            await this.$store
                .dispatch("pritem/GetSummaryPrItem", {cycle, deliveryUnitId, departmentId})
                .then((res) => {
                    if(res.data.error){
                        this.availableBusy = false;
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.availableBusy = false;
                    res.data.map(a => {
                        a.searchKey = a.fundSource;
                        a.fundClassifications.map(b => {
                            a.searchKey += ` ${b.ppmpNumber} ${b.fundClassification}`;
                            b.searchKey = `${a.fundSource} ${b.ppmpNumber} ${b.fundClassification}`;
                            b.selectedPPMP = false;
                            b.checkAllFC = false;
                            b.apis.map(y => {
                                a.searchKey += ` ${y.apiNumber} ${y.apiTitle.trim()}`;
                                b.searchKey += ` ${y.apiNumber} ${y.apiTitle.trim()}`;
                                y.searchKey = `${a.fundSource} ${b.ppmpNumber} ${b.fundClassification} ${y.apiNumber} ${y.apiTitle.trim()}`;
                                y.checkAllWork = false;
                                y.availableApiResourceItems.forEach((item) => {
                                    a.searchKey += ` ${item.name} ${item.description}`;
                                    b.searchKey += ` ${item.name} ${item.description}`;
                                    y.searchKey += ` ${item.name} ${item.description}`;
                                    item.searchKey = `${a.fundSource.sourceName} ${b.ppmpNumber} ${b.fundClassification} ${y.apiNumber} ${y.apiTitle.trim()} ${item.name} ${item.description}`;
                                    item.fundClassificationId = b.fundClassificationId;
                                    item.toggleSelected = false;
                                    item.editQty = true;
                                    item.submitError = false;
                                    item.q1Available = item.q1;
                                    item.q2Available = item.q2;
                                    item.q3Available = item.q3;
                                    item.q4Available = item.q4;
                                    item.Jan = item.january > 0 ? 2 : 0;
                                    item.JanValue = parseFloat(item.january).toString();
                                    item.JanMax = parseFloat(item.january);

                                    item.Feb = item.february > 0 ? 2 : 0;
                                    item.FebValue = parseFloat(item.february).toString();
                                    item.FebMax = parseFloat(item.february);

                                    item.Mar = item.march > 0 ? 2 : 0;
                                    item.MarValue = parseFloat(item.march).toString();
                                    item.MarMax = parseFloat(item.march);

                                    item.Apr = item.april > 0 ? 2 : 0;
                                    item.AprValue = parseFloat(item.april).toString();
                                    item.AprMax = parseFloat(item.april);

                                    item.May = item.may > 0 ? 2 : 0;
                                    item.MayValue = parseFloat(item.may).toString();
                                    item.MayMax = parseFloat(item.may);

                                    item.June = item.june > 0 ? 2 : 0;
                                    item.JuneValue = parseFloat(item.june).toString();
                                    item.JuneMax = parseFloat(item.june);

                                    item.July = item.july > 0 ? 2 : 0;
                                    item.JulyValue = parseFloat(item.july).toString();
                                    item.JulyMax = parseFloat(item.july);

                                    item.Aug = item.august > 0 ? 2 : 0;
                                    item.AugValue = parseFloat(item.august).toString();
                                    item.AugMax = parseFloat(item.august);

                                    item.Sep = item.september > 0 ? 2 : 0;
                                    item.SepValue = parseFloat(item.september).toString();
                                    item.SepMax = parseFloat(item.september);

                                    item.Oct = item.october > 0 ? 2 : 0;
                                    item.OctValue = parseFloat(item.october).toString();
                                    item.OctMax = parseFloat(item.october);

                                    item.Nov = item.november > 0 ? 2 : 0;
                                    item.NovValue = parseFloat(item.november).toString();
                                    item.NovMax = parseFloat(item.november);

                                    item.Dec = item.december > 0 ? 2 : 0;
                                    item.DecValue = parseFloat(item.december).toString();
                                    item.DecMax = parseFloat(item.december);
                                });
                            });
                        })
                    })
                    this.availableTable = res.data;
                })
                .catch((err) => {
                    this.availableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        async getCartItems(cycle, deliveryUnitId, departmentId) {
            this.cartCount = 0;
            await this.$store
                .dispatch("pr/GetNewPRCarts", {cycle, deliveryUnitId, departmentId })
                .then((res) => {
                    if(res.data.error){
                        this.cartBusy = false;
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    if(!res.data) return;
                    this.pr = {
                        id: res.data.id,
                        description: res.data.description,
                        endUserName: res.data.endUser,
                        endUserId: res.data.endUserId,
                        deliveryLocation: res.data.deliveryLocation,
                        deliveryPeriod: res.data.deliveryPeriod.toString(),
                    };
                    let carts = res.data.prItems;
                    carts.map(item => {
                        item.editMode = false;
                        item.editQty = false;
                        item.submitError = false;
                        item.searchKey = `${item.itemName} ${item.description}`;
                        item.prItemAvailableDetails.map(y => {
                            if (y.monthId == 1) {
                                item.Jan = 2;
                                item.JanMax = parseFloat(y.availableQuantity);
                            }
                            if (y.monthId == 2) {
                                item.Feb = 2;
                                item.FebMax = parseFloat(y.availableQuantity);
                            }
                            if (y.monthId == 3) {
                                item.Mar = 2;
                                item.MarMax = parseFloat(y.availableQuantity);
                            }
                            if (y.monthId == 4) {
                                item.Apr = 2;
                                item.AprMax = parseFloat(y.availableQuantity);
                            }
                            if (y.monthId == 5) {
                                item.May = 2;
                                item.MayMax = parseFloat(y.availableQuantity);
                            }
                            if (y.monthId == 6) {
                                item.June = 2;
                                item.JuneMax = parseFloat(y.availableQuantity);
                            }
                            if (y.monthId == 7) {
                                item.July = 2;
                                item.JulyMax = parseFloat(y.availableQuantity);
                            }
                            if (y.monthId == 8) {
                                item.Aug = 2;
                                item.AugMax = parseFloat(y.availableQuantity);
                            }
                            if (y.monthId == 9) {
                                item.Sep = 2;
                                item.SepMax = parseFloat(y.availableQuantity);
                            }
                            if (y.monthId == 10) {
                                item.Oct = 2;
                                item.OctMax = parseFloat(y.availableQuantity);
                            }
                            if (y.monthId == 11) {
                                item.Nov = 2;
                                item.NovMax = parseFloat(y.availableQuantity);
                            }
                            if (y.monthId == 12) {
                                item.Dec = 2;
                                item.DecMax = parseFloat(y.availableQuantity);
                            }
                        });
                        item.prItemDetails.forEach((x) => {
                            if (x.monthId == 1 && item.Jan == 2) {
                                item.JanId = x.id;
                                item.JanValue = parseFloat(x.quantity).toString();
                                item.JanMax += parseFloat(x.quantity);
                            }
                            if (x.monthId == 2 && item.Feb == 2) {
                                item.FebId = x.id;
                                item.FebValue = parseFloat(x.quantity).toString();
                                item.FebMax += parseFloat(x.quantity);
                            }
                            if (x.monthId == 3 && item.Mar == 2) {
                                item.MarId = x.id;
                                item.MarValue = parseFloat(x.quantity).toString();
                                item.MarMax += parseFloat(x.quantity);
                            }
                            if (x.monthId == 4 && item.Apr == 2) {
                                item.AprId = x.id;
                                item.AprValue = parseFloat(x.quantity).toString();
                                item.AprMax += parseFloat(x.quantity);
                            }
                            if (x.monthId == 5 && item.May == 2) {
                                item.MayId = x.id;
                                item.MayValue = parseFloat(x.quantity).toString();
                                item.MayMax += parseFloat(x.quantity);
                            }
                            if (x.monthId == 6 && item.June == 2) {
                                item.JuneId = x.id;
                                item.JuneValue = parseFloat(x.quantity).toString();
                                item.JuneMax += parseFloat(x.quantity);
                            }
                            if (x.monthId == 7 && item.July == 2) {
                                item.JulyId = x.id;
                                item.JulyValue = parseFloat(x.quantity).toString();
                                item.JulyMax += parseFloat(x.quantity);
                            }
                            if (x.monthId == 8 && item.Aug == 2) {
                                item.AugId = x.id;
                                item.AugValue = parseFloat(x.quantity).toString();
                                item.AugMax += parseFloat(x.quantity);
                            }
                            if (x.monthId == 9 && item.Sep == 2) {
                                item.SepId = x.id;
                                item.SepValue = parseFloat(x.quantity).toString();
                                item.SepMax += parseFloat(x.quantity);
                            }
                            if (x.monthId == 10 && item.Oct == 2) {
                                item.OctId = x.id;
                                item.OctValue = parseFloat(x.quantity).toString();
                                item.OctMax += parseFloat(x.quantity);
                            }
                            if (x.monthId == 11 && item.Nov == 2) {
                                item.NovId = x.id;
                                item.NovValue = parseFloat(x.quantity).toString();
                                item.NovMax += parseFloat(x.quantity);
                            }
                            if (x.monthId == 12 && item.Dec == 2) {
                                item.DecId = x.id;
                                item.DecValue = parseFloat(x.quantity).toString();
                                item.DecMax += parseFloat(x.quantity);
                            }
                        });
                    })
                    this.cartItems = carts;
                    this.cartCount = carts.length;
                    this.getPRAttachments(this.pr.id);
                    this.cartBusy = false;
                })
                .catch((err) => {
                    this.cartBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        async getPrCartItems(id, fundClassId){
            this.cartItems = [];
            this.cartBusy = true;
            await this.$store
                .dispatch("pritem/GetPrItems", id)
                .then((res) => {
                    if (res.data) {
                        res.data.forEach((item) => {
                            item.fundClassificationId = fundClassId;
                            item.editMode = false;
                            item.editQty = false;
                            item.submitError = false;
                            item.searchKey = `${item.apiResource.itemName} ${item.apiResource.description}`;
                            item.apiResource.apiResourceDetails.forEach((y) => {
                                if (y.monthId == 1) {
                                    item.Jan = 2;
                                    item.JanMax = parseFloat(y.available);
                                }
                                if (y.monthId == 2) {
                                    item.Feb = 2;
                                    item.FebMax = parseFloat(y.available);
                                }
                                if (y.monthId == 3) {
                                    item.Mar = 2;
                                    item.MarMax = parseFloat(y.available);
                                }
                                if (y.monthId == 4) {
                                    item.Apr = 2;
                                    item.AprMax = parseFloat(y.available);
                                }
                                if (y.monthId == 5) {
                                    item.May = 2;
                                    item.MayMax = parseFloat(y.available);
                                }
                                if (y.monthId == 6) {
                                    item.June = 2;
                                    item.JuneMax = parseFloat(y.available);
                                }
                                if (y.monthId == 7) {
                                    item.July = 2;
                                    item.JulyMax = parseFloat(y.available);
                                }
                                if (y.monthId == 8) {
                                    item.Aug = 2;
                                    item.AugMax = parseFloat(y.available);
                                }
                                if (y.monthId == 9) {
                                    item.Sep = 2;
                                    item.SepMax = parseFloat(y.available);
                                }
                                if (y.monthId == 10) {
                                    item.Oct = 2;
                                    item.OctMax = parseFloat(y.available);
                                }
                                if (y.monthId == 11) {
                                    item.Nov = 2;
                                    item.NovMax = parseFloat(y.available);
                                }
                                if (y.monthId == 12) {
                                    item.Dec = 2;
                                    item.DecMax = parseFloat(y.available);
                                }
                            });
                            item.prItemDetails.forEach((x) => {
                                if (item.Jan == 2) {
                                    if (x.monthId == 1) {
                                        item.JanId = x.id;
                                        item.JanValue = parseFloat(
                                            x.quantity
                                        ).toString();
                                        item.JanMax += parseFloat(x.quantity);
                                    }
                                }
                                if (item.Feb == 2) {
                                    if (x.monthId == 2) {
                                        item.FebId = x.id;
                                        item.FebValue = parseFloat(
                                            x.quantity
                                        ).toString();
                                        item.FebMax += parseFloat(x.quantity);
                                    }
                                }
                                if (item.Mar == 2) {
                                    if (x.monthId == 3) {
                                        item.MarId = x.id;
                                        item.MarValue = parseFloat(
                                            x.quantity
                                        ).toString();
                                        item.MarMax += parseFloat(x.quantity);
                                    }
                                }
                                if (item.Apr == 2) {
                                    if (x.monthId == 4) {
                                        item.AprId = x.id;
                                        item.AprValue = parseFloat(
                                            x.quantity
                                        ).toString();
                                        item.AprMax += parseFloat(x.quantity);
                                    }
                                }
                                if (item.May == 2) {
                                    if (x.monthId == 5) {
                                        item.MayId = x.id;
                                        item.MayValue = parseFloat(
                                            x.quantity
                                        ).toString();
                                        item.MayMax += parseFloat(x.quantity);
                                    }
                                }
                                if (item.June == 2) {
                                    if (x.monthId == 6) {
                                        item.JuneId = x.id;
                                        item.JuneValue = parseFloat(
                                            x.quantity
                                        ).toString();
                                        item.JuneMax += parseFloat(x.quantity);
                                    }
                                }
                                if (item.July == 2) {
                                    if (x.monthId == 7) {
                                        item.JulyId = x.id;
                                        item.JulyValue = parseFloat(
                                            x.quantity
                                        ).toString();
                                        item.JulyMax += parseFloat(x.quantity);
                                    }
                                }
                                if (item.Aug == 2) {
                                    if (x.monthId == 8) {
                                        item.AugId = x.id;
                                        item.AugValue = parseFloat(
                                            x.quantity
                                        ).toString();
                                        item.AugMax += parseFloat(x.quantity);
                                    }
                                }
                                if (item.Sep == 2) {
                                    if (x.monthId == 9) {
                                        item.SepId = x.id;
                                        item.SepValue = parseFloat(
                                            x.quantity
                                        ).toString();
                                        item.SepMax += parseFloat(x.quantity);
                                    }
                                }
                                if (item.Oct == 2) {
                                    if (x.monthId == 10) {
                                        item.OctId = x.id;
                                        item.OctValue = parseFloat(
                                            x.quantity
                                        ).toString();
                                        item.OctMax += parseFloat(x.quantity);
                                    }
                                }
                                if (item.Nov == 2) {
                                    if (x.monthId == 11) {
                                        item.NovId = x.id;
                                        item.NovValue = parseFloat(
                                            x.quantity
                                        ).toString();
                                        item.NovMax += parseFloat(x.quantity);
                                    }
                                }
                                if (item.Dec == 2) {
                                    if (x.monthId == 12) {
                                        item.DecId = x.id;
                                        item.DecValue = parseFloat(
                                            x.quantity
                                        ).toString();
                                        item.DecMax += parseFloat(x.quantity);
                                    }
                                }
                            });
                        });
                        this.cartItems = res.data;
                        this.cartCount = this.cartItems.length;
                        this.cartBusy = false;
                    } else {
                        this.cartCount = 0;
                        this.cartBusy = false;
                    }
                })
                .catch((err) => {
                    this.cartBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        async getAllMyPR(cycle, deliveryUnitId, departmentId) {
            this.prData = [];
            this.posted = [];
            this.approved = [];
            this.returned = [];
            this.prBusy = true;
            await this.$store
                .dispatch("pr/GetPrByCycle", {cycle, deliveryUnitId, departmentId})
                .then((res) => {
                    this.prBusy = false;
                    if (res.data.error) {
                        return this.showToast(
                            res.errorMessage.message,
                            "error"
                        );
                    }
                    res.data.forEach((item) => {
                        item.attachmentLoading = false;
                        item.visible = false;
                        item.itemLoaded = false;
                        item.itemLoading = false;
                        item.attachments = [];
                        item.status = item.status.toUpperCase();
                        item.showAttachments = false;
                        item.fileSearch = "";
                        item.searchKey = `${item.description} ${item.prNumber}`;
                    });
                    this.prData = res.data;
                    var grouped = groupBy(res.data, "status");
                    for (const key in grouped) {
                        if (key.includes("POST")) {
                            this.posted = grouped[key];
                        } else if (key.includes("APPROVE")) {
                            grouped[key].forEach((item) => {
                                this.approved.push(item);
                            });
                        } else if (key.includes("RETURN")) {
                            this.returned = grouped[key];
                        } else if (key.includes("SUBMITTED")) {
                            grouped[key].forEach((item) => {
                                this.approved.push(item);
                            });
                        }
                    }
                    if(this.$route.params.id){
                        this.tabIndex = 2;
                        this.pillsIndex = 1;
                        this.$nextTick(() => {
                            this.$refs[`card-pr-${this.$route.params.id}`][0].classList.add('resource-bg');
                            setTimeout(() => {
                                var top = this.$refs[`card-pr-${this.$route.params.id}`][0].offsetTop;
                                window.scrollTo(0, top);
                            }, 300)
                        });
                    }
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            await this.$store
                .dispatch("pr/GetReturnedPr", {cycle, deliveryUnitId})
                .then((res) => {
                    if (res.data.error) {
                        return (this.alert = {
                            type: "success",
                            message: res.data.errorMessage,
                        });
                    }
                    res.data.forEach((item) => {
                        item.attachmentLoading = false;
                        item.visible = false;
                        item.itemLoaded = false;
                        item.itemLoading = false;
                        item.attachments = [];
                        item.status = item.status.toUpperCase();
                        item.showAttachments = false;
                        item.fileSearch = "";
                        item.searchKey = `${item.description} ${item.prNumber}`;
                    });
                    this.returned = res.data
                })
                .catch((err) => {
                    this.cartBusy = false;
                    this.alert = {
                        type: "danger",
                        message: "Something went wrong!",
                    };
                });
            this.prBusy = false;
        },
        refreshData(idx) {
            if (idx == this.tabIndex) return;
            if (idx == 0) {
                // this.getAvailableItems(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id);
            } else if (idx == 1) {
                this.showUpdatePR = false;
                // this.getCartItems(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id);
            } else if (idx == 2) {
                this.getAllMyPR(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id, this.$store.state.data.selectedDepartment.id);
            }
        },
        toggleSelectionMode() {
            // this.singleSelection = !this.singleSelection;
            // this.availableTable.forEach((item) => {
            //     item.checkAllWork = false;
            //     this.checkEntireWork(item);
            // });
        },
        checkEntireFC(b){
            b.checkAllFC = !b.checkAllFC;
            b.apis.forEach((x) => {
                x.checkAllWork = b.checkAllFC;
                this.checkEntireWork(x)
            });
        },
        checkEntireWork(x, b) {
            x.availableApiResourceItems.forEach((item) => {
                if(!item.isMixed){
                    item.toggleSelected = x.checkAllWork;
                }
            });
            if(b){
                b.checkAllFC = b.apis.every((item) => item.checkAllWork);
            }
        },
        checkApiResource(y, b) {
            y.checkAllWork = y.availableApiResourceItems.every((item) => item.toggleSelected);
            if(b){
                b.checkAllFC = b.apis.every((item) => item.checkAllWork);
            }
        },
        sumUp(row) {
            row.submitError = false;
            row.q1 =
                (row.JanValue ? parseFloat(row.JanValue) : 0) +
                (row.FebValue ? parseFloat(row.FebValue) : 0) +
                (row.MarValue ? parseFloat(row.MarValue) : 0);
            row.q2 =
                (row.AprValue ? parseFloat(row.AprValue) : 0) +
                (row.MayValue ? parseFloat(row.MayValue) : 0) +
                (row.JuneValue ? parseFloat(row.JuneValue) : 0);
            row.q3 =
                (row.JulyValue ? parseFloat(row.JulyValue) : 0) +
                (row.AugValue ? parseFloat(row.AugValue) : 0) +
                (row.SepValue ? parseFloat(row.SepValue) : 0);
            row.q4 =
                (row.OctValue ? parseFloat(row.OctValue) : 0) +
                (row.NovValue ? parseFloat(row.NovValue) : 0) +
                (row.DecValue ? parseFloat(row.DecValue) : 0);
            row.quantity = row.q1 + row.q2 + row.q3 + row.q4;
            row.total =
                parseFloat(row.quantity) * parseFloat(row.unitCost);
        },
        addToCart(x) {
            if(this.cartItems.length > 0){
                if(this.cartItems[0].fundClassificationId != x[0].fundClassificationId){
                    return this.showToast("You can only add items from one PPMP to your cart", "warning");
                }
            }
            this.modalTitle = "PR Item Details";
            this.selectedItems = cloneDeep(x);
            this.selectedItems.forEach((item) => {
                item.JanValue = item.Jan ? item.JanMax.toString() : '0';
                item.FebValue = item.Feb ? item.FebMax.toString() : '0';
                item.MarValue = item.Mar ? item.MarMax.toString() : '0';
                item.AprValue = item.Apr ? item.AprMax.toString() : '0';
                item.MayValue = item.May ? item.MayMax.toString() : '0';
                item.JuneValue = item.June ? item.JuneMax.toString() : '0';
                item.JulyValue = item.July ? item.JulyMax.toString() : '0';
                item.AugValue = item.Aug ? item.AugMax.toString() : '0';
                item.SepValue = item.Sep ? item.SepMax.toString() : '0';
                item.OctValue = item.Oct ? item.OctMax.toString() : '0';
                item.NovValue = item.Nov ? item.NovMax.toString() : '0';
                item.DecValue = item.Dec ? item.DecMax.toString() : '0';
                this.sumUp(item);
            });
            this.$bvModal.show("order-details-modal");
        },
        checkItems(row, type = 0) {
            var error = 0;
            var resultArray = [];
            if (row.JanValue || type == 1) {
                if(row.JanValue && row.JanValue > 0){
                    resultArray.push({
                        id: row.JanId ? row.JanId : 0,
                        monthId: 1,
                        quantity: row.JanValue ? parseFloat(row.JanValue) : 0,
                    });
                }
                if (row.JanValue > row.JanMax) {
                    error++;
                }
            }
            if (row.FebValue || type == 1) {
                if(row.FebValue && row.FebValue > 0){
                    resultArray.push({
                        id: row.FebId ? row.FebId : 0,
                        monthId: 2,
                        quantity: row.FebValue ? parseFloat(row.FebValue) : 0,
                    });
                }
                if (row.FebValue > row.FebMax) {
                    error++;
                }
            }
            if (row.MarValue || type == 1) {
                if(row.MarValue && row.MarValue > 0){
                    resultArray.push({
                        id: row.MarId ? row.MarId : 0,
                        monthId: 3,
                        quantity: row.MarValue ? parseFloat(row.MarValue) : 0,
                    });
                }
                if (row.MarValue > row.MarMax) {
                    error++;
                }
            }
            if (row.AprValue || type == 1) {
                if(row.AprValue && row.AprValue > 0){
                    resultArray.push({
                        id: row.AprId ? row.AprId : 0,
                        monthId: 4,
                        quantity: row.AprValue ? parseFloat(row.AprValue) : 0,
                    });
                }
                if (row.AprValue > row.AprMax) {
                    error++;
                }
            }
            if (row.MayValue || type == 1) {
                if(row.MayValue && row.MayValue > 0){
                    resultArray.push({
                        id: row.MayId ? row.MayId : 0,
                        monthId: 5,
                        quantity: row.MayValue ? parseFloat(row.MayValue) : 0,
                    });
                }
                if (row.MayValue > row.MayMax) {
                    error++;
                }
            }
            if (row.JuneValue || type == 1) {
                if(row.JuneValue && row.JuneValue > 0){
                    resultArray.push({
                        id: row.JuneId ? row.JuneId : 0,
                        monthId: 6,
                        quantity: row.JuneValue ? parseFloat(row.JuneValue) : 0,
                    });
                }
                if (row.JuneValue > row.JuneMax) {
                    error++;
                }
            }
            if (row.JulyValue || type == 1) {
                if(row.JulyValue && row.JulyValue > 0){
                    resultArray.push({
                        id: row.JulyId ? row.JulyId : 0,
                        prItemId: row.id,
                        monthId: 7,
                        quantity: row.JulyValue ? parseFloat(row.JulyValue) : 0,
                    });
                }
                if (row.JulyValue > row.JulyMax) {
                    error++;
                }
            }
            if (row.AugValue || type == 1) {
                if(row.AugValue && row.AugValue > 0){
                    resultArray.push({
                        id: row.AugId ? row.AugId : 0,
                        monthId: 8,
                        quantity: row.AugValue ? parseFloat(row.AugValue) : 0,
                    });
                }
                if (row.AugValue > row.AugMax) {
                    error++;
                }
            }
            if (row.SepValue || type == 1) {
                if(row.SepValue && row.SepValue > 0){
                    resultArray.push({
                        id: row.SepId ? row.SepId : 0,
                        monthId: 9,
                        quantity: row.SepValue ? parseFloat(row.SepValue) : 0,
                    });
                }
                if (row.SepValue > row.SepMax) {
                    error++;
                }
            }
            if (row.OctValue || type == 1) {
                if(row.OctValue && row.OctValue > 0){
                    resultArray.push({
                        id: row.OctId ? row.OctId : 0,
                        monthId: 10,
                        quantity: row.OctValue ? parseFloat(row.OctValue) : 0,
                    });
                }
                if (row.OctValue > row.OctMax) {
                    error++;
                }
            }
            if (row.NovValue || type == 1) {
                if(row.NovValue && row.NovValue > 0){
                    resultArray.push({
                        id: row.NovId ? row.NovId : 0,
                        monthId: 11,
                        quantity: row.NovValue ? parseFloat(row.NovValue) : 0,
                    });
                }
                if (row.NovValue > row.NovMax) {
                    error++;
                }
            }
            if (row.DecValue || type == 1) {
                if(row.DecValue && row.DecValue > 0){
                    resultArray.push({
                        id: row.DecId ? row.DecId : 0,
                        monthId: 12,
                        quantity: row.DecValue ? parseFloat(row.DecValue) : 0,
                    });
                }
                if (row.DecValue > row.DecMax) {
                    error++;
                }
            }
            return { result: resultArray, error: error > 0 ? true : false };
        },
        loopMonthsForDeduction(row, result) {
            this.monthsNickname.forEach((item) => {
                if (
                    row[`${item}Value`] &&
                    parseFloat(row[`${item}Value`]) > 0
                ) {
                    result[`${item}Max`] =
                        parseFloat(result[`${item}Max`]) -
                        parseFloat(row[`${item}Value`]);
                    result[`${item}Value`] = result[`${item}Max`];
                }
            });
        },
        totalOrderedAmt() {
            return this.selectedItems.reduce((pv, cv) => {
                return pv + parseFloat(cv.totalAmount);
            }, 0);
        },
        totalCartAmt() {
            return this.cartItems.reduce((pv, cv) => {
                return pv + parseFloat(cv.total);
            }, 0);
        },
        totalUpdateAmt() {
            return this.updateItems.reduce((pv, cv) => {
                return pv + parseFloat(cv.total);
            }, 0);
        },
        deductQty(row) {
            this.availableTable.forEach((item) => {
                let result = item.apiResources.find((x) => x.id == row.id);
                if (result) {
                    this.loopMonthsForDeduction(row, result);
                    this.sumUp(result);
                    if (result.totalQuantity == 0) {
                        let index = this.availableTable.indexOf(item);
                        let itemIndex =
                            this.availableTable[index].apiResources.indexOf(
                                result
                            );
                        this.availableTable[index].apiResources.splice(
                            itemIndex,
                            1
                        );
                        if (
                            this.availableTable[index].apiResources.length == 0
                        ) {
                            this.availableTable.splice(index, 1);
                        }
                    }
                }
            });
        },
        async onCreatePRItems() {
            var errors = 0;
            var responseCount = 0;
            this.selectedItems.forEach((x) => {
                let result = this.checkItems(x);
                responseCount += result.result.length;
                if (result.error) {
                    x.submitError = true;
                    errors++;
                }
            });
            if (errors > 0) {
                return;
            }
            if(responseCount == 0){
                return this.showToast("Please put atleast 1 quantity!", "warning");
            }
            let prItems = []
            this.selectedItems.map(x => {
                prItems.push({
                    apiResourceId: x.id,
                    prItemDetails: this.checkItems(x).result,
                });
            })
            let data = {
                cycle: this.$store.state.data.cycle,
                prItems: prItems,
                deliveryUnitId: this.$store.state.data.selectedDU.id,
                departmentId: this.$store.state.data.selectedDepartment.id
            };
            await this.$store
                .dispatch("pritem/CreateMultiplePrItem", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(
                            res.data.erroMessage,
                            "warning"
                        );
                    }
                    this.getCartItems(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id, this.$store.state.data.selectedDepartment.id);
                    this.getAvailableItems(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id, this.$store.state.data.selectedDepartment.id);
                    this.$bvModal.hide("order-details-modal");
                    this.showToast("Successfully added to cart!", "success");
                })
                .catch((err) => {
                    this.showToast("PR Item went wrong!", "error");
                });
        },
        deleteCartItem(x, type) {
            var index = type === 'submit' ? this.cartItems.indexOf(x) : this.updateItems.indexOf(x);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("pritem/DeletePrItem", x.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "warning"
                                );
                            }
                            if(type === 'submit'){
                                this.cartItems.splice(index, 1);
                                this.cartCount--;
                            }else{
                                this.updateItems.splice(index, 1);
                            }
                            this.showToast("Successfully deleted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        openPopOver(x) {
            x.editQty = true;
            x.submitError = false;
            this.cartVariables = cloneDeep(x);
        },
        hidePopOver(x) {
            x.editQty = false;
        },
        onShownPopOver(x) {
            this.focusRef(this.$refs[`po-${x.id}`][0]);
        },
        focusRef(ref) {
            this.$nextTick(() => {
                this.$nextTick(() => {
                    (ref.$el || ref).focus();
                });
            });
        },
        saveCartItem(x) {
            var index = this.cartItems.indexOf(x);
            let result = this.checkItems(this.cartVariables, 1);
            if (result.error) {
                x.submitError = true;
                return;
            }
            let data = {
                id: x.id,
                prItemDetails: result.result,
            };
            this.$store
                .dispatch("pritem/UpdatePrItem", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.erroMessage, "warning");
                    }
                    this.cartVariables.editQty = false;
                    this.sumUp(this.cartVariables);
                    this.cartItems.splice(index, 1, this.cartVariables);
                    this.getAvailableItems(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id, this.$store.state.data.selectedDepartment.id);
                    this.showToast("Successfully updated!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        savePRItem(x) {
            var index = this.updateItems.indexOf(x);
            let result = this.checkItems(this.cartVariables, 1);
            if (result.error) {
                x.submitError = true;
                return;
            }
            let data = {
                id: x.id,
                prItemDetails: result.result,
            };
            this.$store
                .dispatch("pritem/UpdatePrItem", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.erroMessage, "warning");
                    }
                    this.cartVariables.editQty = false;
                    this.sumUp(this.cartVariables);
                    this.updateItems.splice(index, 1, this.cartVariables);
                    this.showToast("Successfully updated!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        checkOut() {
            this.$v.pr.$touch();
            if (this.$v.pr.$invalid) {
                return;
            }
            if (this.cartItems.length == 0) {
                return this.showToast("Please add items to cart!", "warning");
            }
            let errorCart = [];
            this.cartItems.forEach((x) => {
                if(x.realigned){
                    errorCart.push(x);
                }
            });
            if(errorCart.length > 0){
                return this.showToast(`${errorCart[0].apiResource.itemName} was included in item modification. Please remove it from cart.`, "warning");
            }
            Swal.fire({
                title: "Are you sure?",
                text: "You want to post this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, post it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("pr/PostPr", this.pr)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.erroMessage,
                                    "warning"
                                );
                            }
                            this.cartItems = [];
                            this.cartCount = 0;
                            this.onResetPR();
                            this.tabIndex = 0;
                            this.showToast("Successfully checkout!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        onResetPR() {
            this.pr = {
                id: 0,
                description: "",
                endUserName: "",
                endUserId: "",
                deliveryLocation: "",
                deliveryPeriod: "",
            };
            this.$v.pr.$reset();
        },
        savePR() {
            this.$v.prHeader.$touch();
            if (this.$v.prHeader.$invalid) {
                return;
            }
            if (this.updateItems.length == 0) {
                return this.showToast("Please add items to cart!", "warning");
            }
            Swal.fire({
                title: "Are you sure?",
                text: "You want to save this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, save it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("pr/PostPr", this.prHeader)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.erroMessage,
                                    "warning"
                                );
                            }
                            this.getAllMyPR(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id, this.$store.state.data.selectedDepartment.id);
                            this.tabIndex = 2;
                            this.dismissUpdate();
                            this.showToast("Successfully updated!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        getPrItems(x) {
            x.visible = !x.visible;
            if (x.visible && !x.itemLoaded) {
                x.itemLoading = true;
                this.$store
                    .dispatch("pritem/GetPrItemsSummary", x.id)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(
                                res.data.erroMessage,
                                "warning"
                            );
                        }
                        if(res.data.items){
                            res.data.items.forEach((item) => {
                                item.editQty = false
                            })
                            x.prItems = sortBy(res.data.items, "itemName")
                        }else{
                            x.prItems = [];
                        }
                        x.itemLoading = false;
                        x.itemLoaded = true;
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
        },
        getTotalPerPR(prItems) {
            return prItems.reduce((pv, cv) => {
                return pv + parseFloat(cv.total);
            }, 0);
        },
        async getSinglePrItem(row){
            await this.$store
                .dispatch("pritem/GetPrItemsSummary", row.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(
                            res.data.erroMessage,
                            "warning"
                        );
                    }
                    if(res.data.items){
                        res.data.items.forEach((item) => {
                            item.editQty = false
                        })
                        row.prItems = sortBy(res.data.items, "itemName")
                    }else{
                        row.prItems = [];
                    }
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async updatePR(row) {
            this.showUpdatePR = true;
            await this.wait(200);
            this.tabIndex = 4;
            if(row.prItems.length == 0){
                await this.getSinglePrItem(row);
            }
            row.prItems.forEach((item) => {
                item.submitError = false;
                item.apiResourceDetails.forEach((y) => {
                    if (y.monthId == 1) {
                        item.Jan = 2;
                        item.JanMax = parseFloat(y.quantity);
                    }
                    if (y.monthId == 2) {
                        item.Feb = 2;
                        item.FebMax = parseFloat(y.quantity);
                    }
                    if (y.monthId == 3) {
                        item.Mar = 2;
                        item.MarMax = parseFloat(y.quantity);
                    }
                    if (y.monthId == 4) {
                        item.Apr = 2;
                        item.AprMax = parseFloat(y.quantity);
                    }
                    if (y.monthId == 5) {
                        item.May = 2;
                        item.MayMax = parseFloat(y.quantity);
                    }
                    if (y.monthId == 6) {
                        item.June = 2;
                        item.JuneMax = parseFloat(y.quantity);
                    }
                    if (y.monthId == 7) {
                        item.July = 2;
                        item.JulyMax = parseFloat(y.quantity);
                    }
                    if (y.monthId == 8) {
                        item.Aug = 2;
                        item.AugMax = parseFloat(y.quantity);
                    }
                    if (y.monthId == 9) {
                        item.Sep = 2;
                        item.SepMax = parseFloat(y.quantity);
                    }
                    if (y.monthId == 10) {
                        item.Oct = 2;
                        item.OctMax = parseFloat(y.quantity);
                    }
                    if (y.monthId == 11) {
                        item.Nov = 2;
                        item.NovMax = parseFloat(y.quantity);
                    }
                    if (y.monthId == 12) {
                        item.Dec = 2;
                        item.DecMax = parseFloat(y.quantity);
                    }
                });
                item.prItemDetails.forEach((x) => {
                    if (item.Jan == 2) {
                        if (x.monthId == 1) {
                            item.JanId = x.id;
                            item.JanValue = parseFloat(x.quantity).toString();
                            item.JanMax += parseFloat(x.quantity);
                        }
                    }
                    if (item.Feb == 2) {
                        if (x.monthId == 2) {
                            item.FebId = x.id;
                            item.FebValue = parseFloat(x.quantity).toString();
                            item.FebMax += parseFloat(x.quantity);
                        }
                    }
                    if (item.Mar == 2) {
                        if (x.monthId == 3) {
                            item.MarId = x.id;
                            item.MarValue = parseFloat(x.quantity).toString();
                            item.MarMax += parseFloat(x.quantity);
                        }
                    }
                    if (item.Apr == 2) {
                        if (x.monthId == 4) {
                            item.AprId = x.id;
                            item.AprValue = parseFloat(x.quantity).toString();
                            item.AprMax += parseFloat(x.quantity);
                        }
                    }
                    if (item.May == 2) {
                        if (x.monthId == 5) {
                            item.MayId = x.id;
                            item.MayValue = parseFloat(x.quantity).toString();
                            item.MayMax += parseFloat(x.quantity);
                        }
                    }
                    if (item.June == 2) {
                        if (x.monthId == 6) {
                            item.JuneId = x.id;
                            item.JuneValue = parseFloat(x.quantity).toString();
                            item.JuneMax += parseFloat(x.quantity);
                        }
                    }
                    if (item.July == 2) {
                        if (x.monthId == 7) {
                            item.JulyId = x.id;
                            item.JulyValue = parseFloat(x.quantity).toString();
                            item.JulyMax += parseFloat(x.quantity);
                        }
                    }
                    if (item.Aug == 2) {
                        if (x.monthId == 8) {
                            item.AugId = x.id;
                            item.AugValue = parseFloat(x.quantity).toString();
                            item.AugMax += parseFloat(x.quantity);
                        }
                    }
                    if (item.Sep == 2) {
                        if (x.monthId == 9) {
                            item.SepId = x.id;
                            item.SepValue = parseFloat(x.quantity).toString();
                            item.SepMax += parseFloat(x.quantity);
                        }
                    }
                    if (item.Oct == 2) {
                        if (x.monthId == 10) {
                            item.OctId = x.id;
                            item.OctValue = parseFloat(x.quantity).toString();
                            item.OctMax += parseFloat(x.quantity);
                        }
                    }
                    if (item.Nov == 2) {
                        if (x.monthId == 11) {
                            item.NovId = x.id;
                            item.NovValue = parseFloat(x.quantity).toString();
                            item.NovMax += parseFloat(x.quantity);
                        }
                    }
                    if (item.Dec == 2) {
                        if (x.monthId == 12) {
                            item.DecId = x.id;
                            item.DecValue = parseFloat(x.quantity).toString();
                            item.DecMax += parseFloat(x.quantity);
                        }
                    }
                });
            });
            this.updateItems = row.prItems;
            this.prHeader = {
                id: row.id,
                description: row.description,
                endUserName: row.endUser.completeName,
                endUserId: row.endUser.id,
                deliveryLocation: row.deliveryLocation,
                deliveryPeriod: row.deliveryPeriod.toString(),
            };
            this.getPRAttachments(row.id);
        },
        dismissUpdate() {
            this.tabIndex = 2;
            this.showUpdatePR = false;
            this.updateItems = [];
        },
        openDocument(x) {
            this.readFile(x.id)
        },
        searchDocu(row) {
            let data = row.attachments;
            if (row.fileSearch.trim() != "" && row.fileSearch) {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(row.fileSearch.toUpperCase());
                });
            }
            return data;
        },
        getAttachments(row) {
            row.showAttachments = !row.showAttachments;
            if (row.showAttachments) {
                row.attachments = [];
                row.attachmentLoading = true;
                this.$store
                    .dispatch("filemanager/GetFiles", {
                        id: row.id,
                        type: "Purchase Request",
                        removeLoading: true,
                    })
                    .then((res) => {
                        row.attachmentLoading = false;
                        row.attachments = res.data;
                    })
                    .catch(() => {
                        row.attachmentLoading = false;
                        this.showToast(
                            "Something went wrong! - getting documents",
                            "error"
                        );
                    });
            }
        },
        printPR(id) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Procurement/PR",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        getPRLogs(id){
            this.$refs.prLogs.getData(id);
            this.$bvModal.show("pr-log-modal");
        },
        selectUser(type){
            this.editType = type;
            if(this.$refs.empModal.tableData.length == 0){
                this.$refs.empModal.getAllSelections();
            }
            this.$bvModal.show('employee-modal');
        },
        dropSingleEmployee(e) {
            if(this.editType == 'submit'){
                this.pr.endUserId = e.applicationUser.id;
                this.pr.endUserName = e.firstName + ' ' + e.lastName;
            }else{
                this.prHeader.endUserId = e.applicationUser.id;
                this.prHeader.endUserName = e.firstName + ' ' + e.lastName;
            }
        },
        updateDescription(row, type){
            this.editType = type;
            if(type === 'returned'){
                this.selectedApiResource = {
                    id: row.id,
                    itemName: row.apiResource.itemName,
                    description: row.apiResource.description,
                    unitId: row.apiResource.unitId,
                    unitName: row.apiResource.unit.unitName,
                    itemCategoryId: row.apiResource.itemCategoryId,
                    itemCategoryName: row.apiResource.itemCategory.name,
                    apiResourceId: row.apiResource.id
                }
            }else{
                this.selectedApiResource = {
                    id: row.id,
                    itemName: row.itemName,
                    description: row.description,
                    unitId: row.unitId,
                    unitName: row.unit,
                    itemCategoryId: row.itemCategoryId,
                    itemCategoryName: row.itemCategory,
                    apiResourceId: row.apiResourceId
                }
            }
            this.$refs.itemUpdate.transferData(this.selectedApiResource);
            this.$bvModal.show('update-description-modal')
        },
        updateDescriptionSubmit(modalData){
            let data = cloneDeep(modalData);
            this.$store.dispatch('apiresource/UpdatePPMPSomeItem', data).then(res => {
                if(res.data.error){
                    return this.showToast(res.data.errorMessage, 'error')
                }
                if(this.editType === 'submit'){
                    let index = this.cartItems.findIndex(x => x.id === modalData.prItemId)
                    this.cartItems[index].apiResource.description = modalData.description;
                }else if(this.editType === 'returned'){
                    let index = this.returnedItems.findIndex(x => x.id === modalData.id)
                    this.returnedItems[index].apiResource.description = modalData.description;
                    this.returnedItems[index].apiResource.itemName = modalData.itemName;
                }else{
                    let index = this.updateItems.findIndex(x => x.id == modalData.id)
                    if(index > -1){
                        this.updateItems[index].description = modalData.description;
                        this.updateItems[index].itemName = modalData.itemName;
                        this.updateItems[index].unitId = modalData.unitId;
                        this.updateItems[index].unit = modalData.unitName;
                        this.updateItems[index].itemCategoryId = data.itemCategoryId;
                        this.updateItems[index].itemCategory = data.itemCategoryName;
                    }
                }
                this.$bvModal.hide('update-description-modal')
                this.showToast('Successfully updated!', 'success')
            }).catch(err => {
                this.showToast('Something went wrong!', 'error')
            })
        },
        async getPRAttachments(id){
            this.$refs.attachmentModal.setUploadOpt({
                type: "Purchase Request",
                placement: "left",
                folder: "Procurement",
            });
            await this.$refs.attachmentModal.getData(id);
            this.attachmentCount = this.$refs.attachmentModal.getCount();
        },
        addAttachment(){
            this.$bvModal.show("upload-attachment-modal");
        },
        dropAttachmentCount(count){
            this.attachmentCount = count;
        },
        updatePRDescription(row, type){
            this.selectedPRCopy = cloneDeep(row);
            this.selectedPR = {
                id: row.id,
                description: row.description,
                datePosted: new Date(row.datePosted),
                selectedType: type,
            }
            this.$bvModal.show('update-pr-description-modal')
        },
        async updatePRDescriptionSubmit(){
            this.submitted = true;
            this.$v.selectedPR.$touch();
            if (this.$v.selectedPR.$invalid) {
                return;
            }
            var error = 0;
            if(this.selectedPR.description.trim() != this.selectedPRCopy.description.trim()){
                await this.$store.dispatch('pr/UpdatePrDescription', {
                    id: this.selectedPR.id,
                    description: this.selectedPR.description,
                }).then(res => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error')
                    }
                    if(this.selectedPR.selectedType === 'posted'){
                        let index = this.posted.findIndex(x => x.id === this.selectedPR.id)
                        this.posted[index].description = this.selectedPR.description;
                    }else{
                        let index = this.approved.findIndex(x => x.id === this.selectedPR.id)
                        this.approved[index].description = this.selectedPR.description;
                    }
                }).catch(err => {
                    error++;
                })
            }
            if(this.getDate(this.selectedPR.datePosted) != this.getDate(new Date(this.selectedPRCopy.datePosted))){
                await this.$store.dispatch('pr/UpdatePrDate', {
                    id: this.selectedPR.id,
                    datePosted: this.getDate(this.selectedPR.datePosted),
                }).then(res => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error')
                    }
                }).catch(err => {
                    error++;
                })
            }
            if(error > 0){
                this.showToast('Something went wrong!', 'error')
            }else{
                this.showToast('PR updated!', 'success')
                this.$bvModal.hide('update-pr-description-modal')
            }

        },
        unselectAllPPMP(){
            this.availableTable.map(x => {
                x.fundClassifications.map(row => {
                    this.unSelectThisPPMP(row);
                })
            })
        },
        selectThisPPMP(row){
            this.unselectAllPPMP();
            row.selectedPPMP = true;
            row.apis.map(x => {
                x.checkAllWork = false;
                x.availableApiResourceItems.map(y => {
                    y.toggleSelected = false;
                })
            });
            row.checkAllFC =  false;
        },
        unSelectThisPPMP(row){
            row.selectedPPMP = false;
            row.apis.map(x => {
                x.checkAllWork = false;
                x.availableApiResourceItems.map(y => {
                    y.toggleSelected = false;
                })
            });
            row.checkAllFC = false;
        },
        deletePR(x){
            var index = this.returned.indexOf(x);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("pr/DeletePr", x.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "warning"
                                );
                            }
                            this.returned.splice(index, 1);
                            this.showToast("Successfully deleted!", "success");
                        })
                        .catch((err) => {
                            this.showToast(
                                "Something went wrong - deleting RFQ",
                                "error"
                            );
                        });
                }
            });
        },
        transferItem(pr, prItemId){
            if(!this.selectedReturnPR){
                return this.showToast('Please select a PR to transfer!', 'warning')
            }
            let index = pr.prItems.findIndex(x => x.id == prItemId)
            let oldPr = pr.prItems[index];
            Swal.fire({
                title: 'Are you sure?',
                text: `You want to transfer this item?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, transfer it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.dispatch('pritem/TransferPrItem', {prItemId: prItemId, prId: this.selectedReturnPR}).then(res => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error')
                        }
                        let prIndex = this.returned.findIndex(x => x.id == this.selectedReturnPR)
                        this.returned[prIndex].prItems.push(oldPr)
                        pr.prItems.splice(index, 1);
                        this.showToast('Item transferred!', 'success')
                    }).catch(err => {
                        this.showToast('Something went wrong!', 'error')
                    })
                }
            })
        },
        getItemCategory() {
            this.$bvModal.show("item-category-modal");
        },
        dropItemCat(data) {
            this.selectedApiResource.itemCategoryId = data.id;
            this.selectedApiResource.itemCategoryName = data.name;
        },
        getUnit() {
            this.$refs.unit.getData();
            this.$bvModal.show("unit-modal");
        },
        dropUnit(data) {
            this.selectedApiResource.unitName = data.shortName;
            this.selectedApiResource.unitId = data.id;
        },
        resubmitItem(row){
            this.$store.dispatch('pritem/ResubmitPrItem', row.id).then(res => {
                if(res.data.error){
                    return this.showToast(res.data.errorMessage, 'error')
                }
                let prIndex = this.returnedItems.findIndex(x => x.id == row.id)
                this.returnedItems.splice(prIndex, 1);
                this.showToast('Item resubmitted!', 'success')
            }).catch(err => {
                this.showToast('Something went wrong!', 'error')
            })
        },
        handleMouseDown(e, item, type) {
            if(item.withChild){
                return;
            }
            this.movePrItem = item;
            e.target.style.cursor = 'grabbing';
            e.target.parentNode.parentNode.setAttribute('draggable', 'true');
        },
        handleMouseUp(e, item, type) {
            if(item.withChild){
                return;
            }
            e.target.style.cursor = 'grab';
            e.target.parentNode.parentNode.setAttribute('draggable', 'false');
        },
        onDropZone(e, item, type) {
            if(this.movePrItem.id == item.id){
                return;
            }
            if(this.movePrItem.unitCost != item.unitCost){
                this.showToast('Cannot consolidate items with different unit cost!', 'error')
                return;
            }
            Swal.fire({
                title: 'Are you sure?',
                text: `You want to consolidate item '${this.movePrItem.apiResource.itemName}' to '${item.apiResource.itemName}'?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, transfer it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("pritem/SetParentPrItem", {
                            prItemId: this.movePrItem.id,
                            parentId: item.id,
                        })
                        .then((res) => {
                            let index = -1;
                            if(type === 'cart'){
                                index = this.cartItems.findIndex(x => x.id == this.movePrItem.id)
                            }else{
                                index = this.updateItems.findIndex(x => x.id == this.movePrItem.id)
                            }
                            item.withChild = true;
                            item.totalQuantity += this.movePrItem.totalQuantity;
                            item.total += this.movePrItem.total;
                            if(type === 'cart'){
                                this.cartItems.splice(index, 1)
                            }else{
                                this.updateItems.splice(index, 1)
                            }
                            this.showToast("Successfully consolidated!", "success");
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            })
        },
        viewConsolidatedItems(id, type){
            this.$bvModal.show('consolidated-item-modal')
            this.consolidationType = type;
            this.selectedParentPrItemId = id;
            this.getConsolidatedItems(id)
        },
        async getConsolidatedItems(id){
            this.showConsolidatedItems = true;
            await this.$store
                .dispatch("pritem/GetItemByParent", id)
                .then((res) => {
                    this.consolidatedItems = res.data.items;
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!","error");
                });
            this.showConsolidatedItems = false;
        },
        removeFromConsolidation(row){
            this.$store
                .dispatch("pritem/SetParentPrItem", {
                    prItemId: row.id,
                    parentId: 0,
                })
                .then((res) => {
                    let index = this.consolidatedItems.findIndex(x => x.id == row.id)
                    if(this.consolidationType === 'cart'){
                        this.cartItems.push(row);
                    }else{
                        this.updateItems.push(row);
                    }
                    this.consolidatedItems.splice(index, 1)
                    if(this.consolidationType === 'cart'){
                        let parentIndex = this.cartItems.findIndex(x => x.id == this.selectedParentPrItemId)
                        this.cartItems[parentIndex].totalQuantity -= row.totalQuantity;
                        this.cartItems[parentIndex].total -= row.total;
                        if(this.consolidatedItems.length == 0){
                            this.cartItems[parentIndex].withChild = false;
                            this.$bvModal.hide('consolidated-item-modal')
                        }
                    }else{
                        let parentIndex = this.updateItems.findIndex(x => x.id == this.selectedParentPrItemId)
                        this.updateItems[parentIndex].totalQuantity -= row.totalQuantity;
                        this.updateItems[parentIndex].total -= row.total;
                        if(this.consolidatedItems.length == 0){
                            this.updateItems[parentIndex].withChild = false;
                            this.$bvModal.hide('consolidated-item-modal')
                        }
                    }
                    this.showToast("Successfully removed!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        filteredFundClass(fundClass){
            let data = fundClass;
            if (this.filterItem.trim() != "" && this.filterItem) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterItem.toUpperCase());
                });
            }
            return data;
        },
        filteredApis(apis){
            let data = apis;
            if (this.filterItem.trim() != "" && this.filterItem) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterItem.toUpperCase());
                });
            }
            return data;
        },
        filteredResources(resources){
            let data = resources;
            if (this.filterItem.trim() != "" && this.filterItem) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filterItem.toUpperCase());
                });
            }
            return data;
        },
    },
};
</script>
<template>
    <Layout @changeCycle="changeCycle" @changeDepartment="changeDepartment($event.id)">
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="order-details-modal"
            :title="modalTitle"
            size="lg"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreatePRItems"
                class="needs-validation"
                ref="apiForm"
            >
                <b-row>
                    <b-col>
                        <table class="table table-centered">
                            <thead>
                                <tr>
                                    <th scope="col">Product Name</th>
                                    <th scope="col" width="150px">Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="x in selectedItems">
                                    <tr :key="x.id">
                                        <td>
                                            <div>
                                                <h5 class="mb-0 text-normal">
                                                    {{ x.name }}
                                                </h5>
                                                <small
                                                    >{{
                                                        formatCurrency(
                                                            x.unitCost
                                                        )
                                                    }}
                                                    X {{ x.totalQuantity }}
                                                    <a
                                                        href="javascript:void(0);"
                                                        @click="
                                                            x.editQty =
                                                                !x.editQty
                                                        "
                                                        >[{{
                                                            x.editQty
                                                                ? "Hide"
                                                                : "Edit"
                                                        }}
                                                        Quantity]</a
                                                    ></small
                                                >
                                                <span
                                                    v-if="x.submitError"
                                                    class="badge bg-danger ms-2"
                                                    >Qty must not exceed to
                                                    available</span
                                                >
                                            </div>
                                        </td>
                                        <td>
                                            {{ formatCurrency(x.totalAmount) }}
                                        </td>
                                    </tr>
                                    <template>
                                        <tr
                                            :key="`qty${x.id}`"
                                            v-if="x.editQty"
                                        >
                                            <td colspan="2">
                                                <table>
                                                    <tr>
                                                        <td
                                                            class="align-middle"
                                                            style="width: 120px"
                                                        >
                                                            Quarter 1
                                                        </td>
                                                        <td>
                                                            <div class="mx-2">
                                                                <small
                                                                    >January</small
                                                                >
                                                                <div
                                                                    v-if="
                                                                        !x.Jan
                                                                    "
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        placeholder="No available quantity"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="
                                                                        text-center
                                                                        position-relative
                                                                    "
                                                                    v-if="
                                                                        x.Jan >
                                                                        1
                                                                    "
                                                                >
                                                                    <masked-input
                                                                        type="text"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        v-model="
                                                                            x.JanValue
                                                                        "
                                                                        :mask="
                                                                            currencyMask
                                                                        "
                                                                        @input="
                                                                            sumUp(
                                                                                x
                                                                            )
                                                                        "
                                                                    ></masked-input>
                                                                    <p
                                                                        v-if="
                                                                            x.JanValue
                                                                        "
                                                                        class="
                                                                            badge
                                                                            position-absolute
                                                                        "
                                                                        style="
                                                                            top: -5px;
                                                                            right: -5px;
                                                                        "
                                                                        :class="{
                                                                            'bg-success':
                                                                                x.JanValue <=
                                                                                x.JanMax,
                                                                            'bg-danger':
                                                                                x.JanValue >
                                                                                x.JanMax,
                                                                        }"
                                                                    >
                                                                        {{
                                                                            x.JanValue
                                                                        }}
                                                                        /
                                                                        {{
                                                                            x.JanMax
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="mx-2">
                                                                <small
                                                                    >February</small
                                                                >
                                                                <div
                                                                    v-if="
                                                                        !x.Feb
                                                                    "
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        placeholder="No available quantity"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="
                                                                        text-center
                                                                        position-relative
                                                                    "
                                                                    v-if="
                                                                        x.Feb >
                                                                        1
                                                                    "
                                                                >
                                                                    <masked-input
                                                                        type="text"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        v-model="
                                                                            x.FebValue
                                                                        "
                                                                        :mask="
                                                                            currencyMask
                                                                        "
                                                                        @input="
                                                                            sumUp(
                                                                                x
                                                                            )
                                                                        "
                                                                    ></masked-input>
                                                                    <p
                                                                        v-if="
                                                                            x.FebValue
                                                                        "
                                                                        class="
                                                                            badge
                                                                            position-absolute
                                                                        "
                                                                        style="
                                                                            top: -5px;
                                                                            right: -5px;
                                                                        "
                                                                        :class="{
                                                                            'bg-success':
                                                                                x.FebValue <=
                                                                                x.FebMax,
                                                                            'bg-danger':
                                                                                x.FebValue >
                                                                                x.FebMax,
                                                                        }"
                                                                    >
                                                                        {{
                                                                            x.FebValue
                                                                        }}
                                                                        /
                                                                        {{
                                                                            x.FebMax
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="mx-2">
                                                                <small
                                                                    >March
                                                                </small>
                                                                <div
                                                                    v-if="
                                                                        !x.Mar
                                                                    "
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        placeholder="No available quantity"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="
                                                                        text-center
                                                                        position-relative
                                                                    "
                                                                    v-if="
                                                                        x.Mar >
                                                                        1
                                                                    "
                                                                >
                                                                    <masked-input
                                                                        type="text"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        v-model="
                                                                            x.MarValue
                                                                        "
                                                                        :mask="
                                                                            currencyMask
                                                                        "
                                                                        @input="
                                                                            sumUp(
                                                                                x
                                                                            )
                                                                        "
                                                                    ></masked-input>
                                                                    <p
                                                                        v-if="
                                                                            x.MarValue
                                                                        "
                                                                        class="
                                                                            badge
                                                                            position-absolute
                                                                        "
                                                                        style="
                                                                            top: -5px;
                                                                            right: -5px;
                                                                        "
                                                                        :class="{
                                                                            'bg-success':
                                                                                x.MarValue <=
                                                                                x.MarMax,
                                                                            'bg-danger':
                                                                                x.MarValue >
                                                                                x.MarMax,
                                                                        }"
                                                                    >
                                                                        {{
                                                                            x.MarValue
                                                                        }}
                                                                        /
                                                                        {{
                                                                            x.MarMax
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            class="align-middle"
                                                            style="width: 120px"
                                                        >
                                                            Quarter 2
                                                        </td>
                                                        <td>
                                                            <div class="mx-2">
                                                                <small
                                                                    >April</small
                                                                >
                                                                <div
                                                                    v-if="
                                                                        !x.Apr
                                                                    "
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        placeholder="No available quantity"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="
                                                                        text-center
                                                                        position-relative
                                                                    "
                                                                    v-if="
                                                                        x.Apr >
                                                                        1
                                                                    "
                                                                >
                                                                    <masked-input
                                                                        type="text"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        v-model="
                                                                            x.AprValue
                                                                        "
                                                                        :mask="
                                                                            currencyMask
                                                                        "
                                                                        @input="
                                                                            sumUp(
                                                                                x
                                                                            )
                                                                        "
                                                                    ></masked-input>
                                                                    <p
                                                                        v-if="
                                                                            x.AprValue
                                                                        "
                                                                        class="
                                                                            badge
                                                                            position-absolute
                                                                        "
                                                                        style="
                                                                            top: -5px;
                                                                            right: -5px;
                                                                        "
                                                                        :class="{
                                                                            'bg-success':
                                                                                x.AprValue <=
                                                                                x.AprMax,
                                                                            'bg-danger':
                                                                                x.AprValue >
                                                                                x.AprMax,
                                                                        }"
                                                                    >
                                                                        {{
                                                                            x.AprValue
                                                                        }}
                                                                        /
                                                                        {{
                                                                            x.AprMax
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="mx-2">
                                                                <small
                                                                    >May</small
                                                                >
                                                                <div
                                                                    v-if="
                                                                        !x.May
                                                                    "
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        placeholder="No available quantity"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="
                                                                        text-center
                                                                        position-relative
                                                                    "
                                                                    v-if="
                                                                        x.May >
                                                                        1
                                                                    "
                                                                >
                                                                    <masked-input
                                                                        type="text"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        v-model="
                                                                            x.MayValue
                                                                        "
                                                                        :mask="
                                                                            currencyMask
                                                                        "
                                                                        @input="
                                                                            sumUp(
                                                                                x
                                                                            )
                                                                        "
                                                                    ></masked-input>
                                                                    <p
                                                                        v-if="
                                                                            x.MayValue
                                                                        "
                                                                        class="
                                                                            badge
                                                                            position-absolute
                                                                        "
                                                                        style="
                                                                            top: -5px;
                                                                            right: -5px;
                                                                        "
                                                                        :class="{
                                                                            'bg-success':
                                                                                x.MayValue <=
                                                                                x.MayMax,
                                                                            'bg-danger':
                                                                                x.MayValue >
                                                                                x.MayMax,
                                                                        }"
                                                                    >
                                                                        {{
                                                                            x.MayValue
                                                                        }}
                                                                        /
                                                                        {{
                                                                            x.MayMax
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="mx-2">
                                                                <small
                                                                    >June
                                                                </small>
                                                                <div
                                                                    v-if="
                                                                        !x.June
                                                                    "
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        placeholder="No available quantity"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="
                                                                        text-center
                                                                        position-relative
                                                                    "
                                                                    v-if="
                                                                        x.June >
                                                                        1
                                                                    "
                                                                >
                                                                    <masked-input
                                                                        type="text"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        v-model="
                                                                            x.JuneValue
                                                                        "
                                                                        :mask="
                                                                            currencyMask
                                                                        "
                                                                        @input="
                                                                            sumUp(
                                                                                x
                                                                            )
                                                                        "
                                                                    ></masked-input>
                                                                    <p
                                                                        v-if="
                                                                            x.JuneValue
                                                                        "
                                                                        class="
                                                                            badge
                                                                            position-absolute
                                                                        "
                                                                        style="
                                                                            top: -5px;
                                                                            right: -5px;
                                                                        "
                                                                        :class="{
                                                                            'bg-success':
                                                                                x.JuneValue <=
                                                                                x.JuneMax,
                                                                            'bg-danger':
                                                                                x.JuneValue >
                                                                                x.JuneMax,
                                                                        }"
                                                                    >
                                                                        {{
                                                                            x.JuneValue
                                                                        }}
                                                                        /
                                                                        {{
                                                                            x.JuneMax
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            class="align-middle"
                                                            style="width: 120px"
                                                        >
                                                            Quarter 3
                                                        </td>
                                                        <td>
                                                            <div class="mx-2">
                                                                <small
                                                                    >July</small
                                                                >
                                                                <div
                                                                    v-if="
                                                                        !x.July
                                                                    "
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        placeholder="No available quantity"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="
                                                                        text-center
                                                                        position-relative
                                                                    "
                                                                    v-if="
                                                                        x.July >
                                                                        1
                                                                    "
                                                                >
                                                                    <masked-input
                                                                        type="text"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        v-model="
                                                                            x.JulyValue
                                                                        "
                                                                        :mask="
                                                                            currencyMask
                                                                        "
                                                                        @input="
                                                                            sumUp(
                                                                                x
                                                                            )
                                                                        "
                                                                    ></masked-input>
                                                                    <p
                                                                        v-if="
                                                                            x.JulyValue
                                                                        "
                                                                        class="
                                                                            badge
                                                                            position-absolute
                                                                        "
                                                                        style="
                                                                            top: -5px;
                                                                            right: -5px;
                                                                        "
                                                                        :class="{
                                                                            'bg-success':
                                                                                x.JulyValue <=
                                                                                x.JulyMax,
                                                                            'bg-danger':
                                                                                x.JulyValue >
                                                                                x.JulyMax,
                                                                        }"
                                                                    >
                                                                        {{
                                                                            x.JulyValue
                                                                        }}
                                                                        /
                                                                        {{
                                                                            x.JulyMax
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="mx-2">
                                                                <small
                                                                    >August</small
                                                                >
                                                                <div
                                                                    v-if="
                                                                        !x.Aug
                                                                    "
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        placeholder="No available quantity"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="
                                                                        text-center
                                                                        position-relative
                                                                    "
                                                                    v-if="
                                                                        x.Aug >
                                                                        1
                                                                    "
                                                                >
                                                                    <masked-input
                                                                        type="text"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        v-model="
                                                                            x.AugValue
                                                                        "
                                                                        :mask="
                                                                            currencyMask
                                                                        "
                                                                        @input="
                                                                            sumUp(
                                                                                x
                                                                            )
                                                                        "
                                                                    ></masked-input>
                                                                    <p
                                                                        v-if="
                                                                            x.AugValue
                                                                        "
                                                                        class="
                                                                            badge
                                                                            position-absolute
                                                                        "
                                                                        style="
                                                                            top: -5px;
                                                                            right: -5px;
                                                                        "
                                                                        :class="{
                                                                            'bg-success':
                                                                                x.AugValue <=
                                                                                x.AugMax,
                                                                            'bg-danger':
                                                                                x.AugValue >
                                                                                x.AugMax,
                                                                        }"
                                                                    >
                                                                        {{
                                                                            x.AugValue
                                                                        }}
                                                                        /
                                                                        {{
                                                                            x.AugMax
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="mx-2">
                                                                <small
                                                                    >September
                                                                </small>
                                                                <div
                                                                    v-if="
                                                                        !x.Sep
                                                                    "
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        placeholder="No available quantity"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="
                                                                        text-center
                                                                        position-relative
                                                                    "
                                                                    v-if="
                                                                        x.Sep >
                                                                        1
                                                                    "
                                                                >
                                                                    <masked-input
                                                                        type="text"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        v-model="
                                                                            x.SepValue
                                                                        "
                                                                        :mask="
                                                                            currencyMask
                                                                        "
                                                                        @input="
                                                                            sumUp(
                                                                                x
                                                                            )
                                                                        "
                                                                    ></masked-input>
                                                                    <p
                                                                        v-if="
                                                                            x.SepValue
                                                                        "
                                                                        class="
                                                                            badge
                                                                            position-absolute
                                                                        "
                                                                        style="
                                                                            top: -5px;
                                                                            right: -5px;
                                                                        "
                                                                        :class="{
                                                                            'bg-success':
                                                                                x.SepValue <=
                                                                                x.SepMax,
                                                                            'bg-danger':
                                                                                x.SepValue >
                                                                                x.SepMax,
                                                                        }"
                                                                    >
                                                                        {{
                                                                            x.SepValue
                                                                        }}
                                                                        /
                                                                        {{
                                                                            x.SepMax
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            class="align-middle"
                                                            style="width: 120px"
                                                        >
                                                            Quarter 4
                                                        </td>
                                                        <td>
                                                            <div class="mx-2">
                                                                <small
                                                                    >October</small
                                                                >
                                                                <div
                                                                    v-if="
                                                                        !x.Oct
                                                                    "
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        placeholder="No available quantity"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="
                                                                        text-center
                                                                        position-relative
                                                                    "
                                                                    v-if="
                                                                        x.Oct >
                                                                        1
                                                                    "
                                                                >
                                                                    <masked-input
                                                                        type="text"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        v-model="
                                                                            x.OctValue
                                                                        "
                                                                        :mask="
                                                                            currencyMask
                                                                        "
                                                                        @input="
                                                                            sumUp(
                                                                                x
                                                                            )
                                                                        "
                                                                    ></masked-input>
                                                                    <p
                                                                        v-if="
                                                                            x.OctValue
                                                                        "
                                                                        class="
                                                                            badge
                                                                            position-absolute
                                                                        "
                                                                        style="
                                                                            top: -5px;
                                                                            right: -5px;
                                                                        "
                                                                        :class="{
                                                                            'bg-success':
                                                                                x.OctValue <=
                                                                                x.OctMax,
                                                                            'bg-danger':
                                                                                x.OctValue >
                                                                                x.OctMax,
                                                                        }"
                                                                    >
                                                                        {{
                                                                            x.OctValue
                                                                        }}
                                                                        /
                                                                        {{
                                                                            x.OctMax
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="mx-2">
                                                                <small
                                                                    >November</small
                                                                >
                                                                <div
                                                                    v-if="
                                                                        !x.Nov
                                                                    "
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        placeholder="No available quantity"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="
                                                                        text-center
                                                                        position-relative
                                                                    "
                                                                    v-if="
                                                                        x.Nov >
                                                                        1
                                                                    "
                                                                >
                                                                    <masked-input
                                                                        type="text"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        v-model="
                                                                            x.NovValue
                                                                        "
                                                                        :mask="
                                                                            currencyMask
                                                                        "
                                                                        @input="
                                                                            sumUp(
                                                                                x
                                                                            )
                                                                        "
                                                                    ></masked-input>
                                                                    <p
                                                                        v-if="
                                                                            x.NovValue
                                                                        "
                                                                        class="
                                                                            badge
                                                                            position-absolute
                                                                        "
                                                                        style="
                                                                            top: -5px;
                                                                            right: -5px;
                                                                        "
                                                                        :class="{
                                                                            'bg-success':
                                                                                x.NovValue <=
                                                                                x.NovMax,
                                                                            'bg-danger':
                                                                                x.NovValue >
                                                                                x.NovMax,
                                                                        }"
                                                                    >
                                                                        {{
                                                                            x.NovValue
                                                                        }}
                                                                        /
                                                                        {{
                                                                            x.NovMax
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="mx-2">
                                                                <small
                                                                    >December
                                                                </small>
                                                                <div
                                                                    v-if="
                                                                        !x.Dec
                                                                    "
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        placeholder="No available quantity"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="
                                                                        text-center
                                                                        position-relative
                                                                    "
                                                                    v-if="
                                                                        x.Dec >
                                                                        1
                                                                    "
                                                                >
                                                                    <masked-input
                                                                        type="text"
                                                                        class="
                                                                            form-control
                                                                        "
                                                                        v-model="
                                                                            x.DecValue
                                                                        "
                                                                        :mask="
                                                                            currencyMask
                                                                        "
                                                                        @input="
                                                                            sumUp(
                                                                                x
                                                                            )
                                                                        "
                                                                    ></masked-input>
                                                                    <p
                                                                        v-if="
                                                                            x.DecValue
                                                                        "
                                                                        class="
                                                                            badge
                                                                            position-absolute
                                                                        "
                                                                        style="
                                                                            top: -5px;
                                                                            right: -5px;
                                                                        "
                                                                        :class="{
                                                                            'bg-success':
                                                                                x.DecValue <=
                                                                                x.DecMax,
                                                                            'bg-danger':
                                                                                x.DecValue >
                                                                                x.DecMax,
                                                                        }"
                                                                    >
                                                                        {{
                                                                            x.DecValue
                                                                        }}
                                                                        /
                                                                        {{
                                                                            x.DecMax
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                                <tr>
                                    <td class="text-right">Total Amount</td>
                                    <td>
                                        {{ formatCurrency(totalOrderedAmt()) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Add to Cart
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('order-details-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="update-description-modal"
            title="Update Description"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <form @submit.prevent="updateDescriptionSubmit" class="needs-validation">
                <div v-if="selectedApiResource">
                    <div class="mb-3" >
                        <label for="description">Item Name</label>
                        <input
                            id="itemName"
                            type="text"
                            autocomplete="off"
                            v-model="selectedApiResource.itemName"
                            placeholder="Enter Item Name..."
                            class="form-control"
                        />
                    </div>
                    <div class="mb-3" >
                        <label for="description">Description </label>
                        <textarea
                            id="descriptionCopy"
                            rows="3"
                            v-model="selectedApiResource.description"
                            placeholder="Enter Description..."
                            class="form-control"
                        ></textarea>
                    </div>
                    <div class="mb-3">
                        <label for="description">Item Category </label>
                        <b-input-group>
                            <template #append>
                                <b-button
                                    @click="
                                        getItemCategory
                                    "
                                    variant="outline-info"
                                    ><i
                                        class="
                                            mdi
                                            mdi-clipboard-text-search-outline
                                        "
                                    ></i
                                ></b-button>
                            </template>
                            <input
                                autocomplete="off"
                                type="text"
                                disabled
                                placeholder="Search Item Category..."
                                class="
                                    form-control text-warning
                                "
                                v-model="
                                    selectedApiResource.itemCategoryName
                                "
                            />
                        </b-input-group>
                    </div>
                    <div class="mb-3">
                        <label for="description">Unit </label>
                        <b-input-group>
                            <template #append>
                                <b-button
                                    @click="
                                        getUnit
                                    "
                                    variant="outline-info"
                                    ><i
                                        class="
                                            mdi
                                            mdi-clipboard-text-search-outline
                                        "
                                    ></i
                                ></b-button>
                            </template>
                            <input
                                autocomplete="off"
                                type="text"
                                disabled
                                placeholder="Search Unit..."
                                class="
                                    form-control text-warning
                                "
                                v-model="
                                    selectedApiResource.unitName
                                "
                            />
                        </b-input-group>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Update
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('update-description-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="update-pr-description-modal"
            title="Update PR"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <form @submit.prevent="updatePRDescriptionSubmit" class="needs-validation" v-if="selectedPR">
                <div class="mb-3">
                    <label for="description">Description </label>
                    <textarea
                        id="descriptionCopy"
                        rows="3"
                        v-model="selectedPR.description"
                        placeholder="Enter Description..."
                        class="form-control"
                        :class="{
                            'is-invalid':
                                submitted && $v.selectedPR.description.$error,
                        }"
                    ></textarea>
                    <div
                        v-if="submitted && $v.selectedPR.description.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.selectedPR.description.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3">
                    <label for="dateCompleted">Date Posted</label>
                    <date-picker 
                        v-model="selectedPR.datePosted" 
                        :first-day-of-week="1"
                        lang="en"
                        placeholder="Enter Date Posted..."
                        :class="{
                            'is-invalid':
                                submitted && $v.selectedPR.datePosted.$error,
                        }"
                    ></date-picker>
                    <div
                        v-if="submitted && $v.selectedPR.datePosted.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.selectedPR.datePosted.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Update PR
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('update-pr-description-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-tabs
            content-class="pt-3 pb-3 text-muted"
            v-model="tabIndex"
            nav-class="nav-tabs-custom"
        >
            <b-tab @click="refreshData(0)">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Available Items</span
                    >
                </template>
                <div class="row">
                    <div class="col-md-6">
                        <h5 class="mb-0">List of Available Items</h5>
                        <div>
                            <small
                                class="cursor-pointer"
                                @click="toggleSelectionMode"
                                >{{
                                    singleSelection
                                        ? "Single Selection"
                                        : "Mutiple Selection"
                                }}</small
                            >
                        </div>
                    </div>
                    <div class="col-md-6 text-right">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter me-1"
                        >
                            <label class="d-inline-flex align-items-center">
                                <b-form-input
                                    autocomplete="off"
                                    v-model="filterItem"
                                    type="search"
                                    placeholder="Search Items..."
                                    class="form-control"
                                ></b-form-input>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div>
                            <div class="">
                                <table
                                    class="
                                        table
                                        project-list-table
                                        table-centered table-borderless
                                    "
                                >
                                    <thead>
                                        <tr>
                                            <th width="50px"></th>
                                            <th
                                                scope="col"
                                                style="width: 500px"
                                                class="
                                                    align-middle
                                                    border-2
                                                    border-top-0
                                                    border-start-0
                                                    border-bottom-0
                                                    border-dark-app
                                                "
                                            >
                                                Item Name
                                            </th>
                                            <th
                                                class="
                                                    text-center
                                                    border-2
                                                    border-top-0
                                                    border-start-0
                                                    border-bottom-0
                                                    border-dark-app
                                                    p-0
                                                "
                                                style="width: 500px"
                                            >
                                                <div class="text-center">
                                                    <div
                                                        class="
                                                            border-dark-bottom
                                                            py-1
                                                        "
                                                    >
                                                        Available Quantity
                                                    </div>
                                                    <div class="d-flex">
                                                        <div
                                                            class="
                                                                w-25
                                                                border-dark-right
                                                                p-1
                                                            "
                                                        >
                                                            Quarter 1
                                                        </div>
                                                        <div
                                                            class="
                                                                w-25
                                                                border-dark-right
                                                                py-1
                                                            "
                                                        >
                                                            Quarter 2
                                                        </div>
                                                        <div
                                                            class="
                                                                w-25
                                                                border-dark-right
                                                                py-1
                                                            "
                                                        >
                                                            Quarter 3
                                                        </div>
                                                        <div class="w-25 py-1">
                                                            Quarter 4
                                                        </div>
                                                    </div>
                                                </div>
                                            </th>
                                            <th
                                                class="
                                                    align-middle
                                                    border-2
                                                    border-top-0
                                                    border-start-0
                                                    border-bottom-0
                                                    border-dark-app
                                                    text-center
                                                "
                                            >
                                                Total Available Qty
                                            </th>
                                            <th
                                                class="
                                                    align-middle
                                                    border-2
                                                    border-top-0
                                                    border-start-0
                                                    border-bottom-0
                                                    border-dark-app
                                                "
                                            >
                                                Unit Cost
                                            </th>
                                            <th
                                                class="
                                                    align-middle
                                                    border-2
                                                    border-top-0
                                                    border-start-0
                                                    border-bottom-0
                                                    border-dark-app
                                                "
                                            >
                                                Total Amount
                                            </th>
                                            <!-- <th
                                                scope="col"
                                                width="120px"
                                                class="text-center align-middle"
                                                v-if="singleSelection"
                                            >
                                                Action
                                            </th> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="availableBusy">
                                            <td colspan="100%">
                                                <div class="d-flex justify-content-center align-items-center">
                                                    <div class="preloader-component me-2">
                                                        <div class="status">
                                                            <div class="spinner-chase w-20px h-20px">
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <strong>Loading...</strong>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr
                                            v-if="
                                                filteredAvailableItems.length ==
                                                    0 && !availableBusy
                                            "
                                        >
                                            <td
                                                colspan="100%"
                                                class="text-muted text-center"
                                            >
                                                <i
                                                    class="
                                                        dripicons-warning
                                                        me-1
                                                    "
                                                ></i
                                                >No data found
                                            </td>
                                        </tr>
                                        <template
                                            v-for="a in filteredAvailableItems"
                                        >
                                            <tr 
                                                :key="a.fundSourceId"
                                                style="
                                                    background-color: transparent;
                                                    box-shadow: none;
                                                "
                                            >
                                                <td colspan="100%" class="py-0 px-0"><h4 class="text-success mb-0 mx-0">{{a.fundSource}}</h4></td>
                                            </tr>
                                            <template v-for="b in filteredFundClass(a.fundClassifications)">
                                                <tr 
                                                    :key="`A${a.fundSourceId}B${b.fundClassificationId}`"
                                                    style="
                                                        background-color: transparent;
                                                        box-shadow: none;
                                                    "
                                                >
                                                    <td  colspan="100%" class="py-0">
                                                        <div v-if="b.selectedPPMP">
                                                            <div class="d-flex justify-content-between">
                                                                <div
                                                                    class="
                                                                        form-check
                                                                        form-checkbox-outline
                                                                        form-check-success
                                                                        mb-0
                                                                    "
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        :id="`fundClass-${b.fundClassificationId}`"
                                                                        class="form-check-input"
                                                                        v-model="b.checkAllFC"
                                                                        @click="checkEntireFC(b)"
                                                                    /><label
                                                                        :for="`fundClass-${b.fundClassificationId}`"
                                                                        class="form-check-label"
                                                                    >
                                                                        <h5
                                                                            class="
                                                                                mb-0
                                                                            "
                                                                        >
                                                                            <span class="text-pink">[{{b.ppmpNumber}}]</span> <span class="text-dark">{{ b.fundClassification }}</span>
                                                                        </h5>
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                        text-warning
                                                                        cursor-pointer
                                                                    "
                                                                    @click="
                                                                        unSelectThisPPMP(b)
                                                                    ">
                                                                    <i class="bx bx-x me-1"></i>
                                                                    Cancel Selection
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <div class="d-flex justify-content-between">
                                                                <h5
                                                                    class="
                                                                        mb-0
                                                                    "
                                                                >
                                                                    <span class="text-pink">[{{b.ppmpNumber}}]</span> <span class="text-dark">{{b.fundClassification}}</span>
                                                                </h5>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                        text-success
                                                                        cursor-pointer
                                                                    "
                                                                    @click="
                                                                        selectThisPPMP(b)
                                                                    "
                                                                >
                                                                    <i
                                                                        class="
                                                                            bx
                                                                            bx-cart
                                                                            me-1
                                                                        "
                                                                    ></i
                                                                    >Select this PPMP
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <template v-for="y in filteredApis(b.apis)">
                                                    <tr
                                                        :key="`A${a.fundSourceId}B${b.fundClassificationId}Y${y.apiId}`"
                                                        style="
                                                            background-color: transparent;
                                                            box-shadow: none;
                                                        "
                                                    >
                                                        <td
                                                            colspan="100%"
                                                            class="py-0 px-4"
                                                        >
                                                            <div v-if="b.selectedPPMP">
                                                                <div class="d-flex justify-content-between">
                                                                    <div
                                                                        class="
                                                                            form-check
                                                                            form-checkbox-outline
                                                                            form-check-success
                                                                            mb-0
                                                                        "
                                                                    >
                                                                        <input
                                                                            type="checkbox"
                                                                            :id="`work-${y.apiId}`"
                                                                            checked="checked"
                                                                            class="form-check-input"
                                                                            v-model="y.checkAllWork"
                                                                            @change="checkEntireWork(y, b)"
                                                                        /><label
                                                                            :for="`work-${y.apiId}`"
                                                                            class="
                                                                                form-check-label
                                                                            "
                                                                        >
                                                                            <h5
                                                                                class="
                                                                                    mb-0
                                                                                "
                                                                            >
                                                                                <span class="text-warning">[{{y.apiNumber}}]</span> <span class="text-dark">{{ y.apiTitle }}</span>
                                                                            </h5>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-else>
                                                                <div class="d-flex justify-content-between">
                                                                    <h5
                                                                        class="
                                                                            mb-0
                                                                        "
                                                                    >
                                                                        <span class="text-warning">[{{y.apiNumber}}]</span> <span class="text-dark">{{ y.apiTitle }}</span>
                                                                    </h5>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <template
                                                        v-for="x in filteredResources(y.availableApiResourceItems)"
                                                    >
                                                        <tr
                                                            :key="`A${a.fundSourceId}B${b.fundClassificationId}Y${y.apiId}X${x.id}`"
                                                            class="position-relative"
                                                            :class="{
                                                                'border-1 border-danger':
                                                                    x.submitError,
                                                            }"
                                                            style="background-color: transparent; box-shadow: none;"
                                                        >
                                                            <td></td>
                                                            <td class="align-middle position-relative"  :class="{'bg-table-tr-disabled': x.isMixed, 'bg-table-tr': !x.isMixed}">
                                                                <RawData :data="x" v-if="$store.state.decrypt.isAdmin()"/>
                                                                <div
                                                                    class="
                                                                        form-check
                                                                        form-checkbox-outline
                                                                        form-check-success
                                                                        mb-0
                                                                        ms-3
                                                                    "
                                                                    v-if="b.selectedPPMP && !x.isMixed"
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        :id="`resources-${x.id}`"
                                                                        checked="checked"
                                                                        class="form-check-input"
                                                                        v-model="x.toggleSelected"
                                                                        @change="checkApiResource(y, b)"
                                                                    /><label
                                                                        :for="`resources-${x.id}`"
                                                                        class="form-check-label"
                                                                    >
                                                                        <span
                                                                            class="
                                                                                cursor-pointer
                                                                            "
                                                                            :id="`popover-${x.id}`"
                                                                            >{{
                                                                                x.name
                                                                            }}
                                                                            ({{
                                                                                x.description
                                                                            }})</span
                                                                        >
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    class="ms-3"
                                                                    v-else
                                                                >
                                                                    <span
                                                                        >{{
                                                                            x.name
                                                                        }}
                                                                        ({{
                                                                            x.description
                                                                        }})</span
                                                                    ><sup v-if="x.isMixed" class="text-warning">[Mixed]</sup>
                                                                </div>
                                                            </td>
                                                            <td class="align-middle p-0" :class="{'bg-table-tr-disabled': x.isMixed, 'bg-table-tr': !x.isMixed}">
                                                                <div
                                                                    class="
                                                                        text-center
                                                                        d-flex
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            w-25
                                                                            d-flex
                                                                            align-items-center
                                                                            justify-content-center
                                                                            py-2
                                                                        "
                                                                    >
                                                                        {{ x.q1Available }}
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            w-25
                                                                            d-flex
                                                                            align-items-center
                                                                            justify-content-center
                                                                        "
                                                                    >
                                                                        {{ x.q2Available }}
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            w-25
                                                                            d-flex
                                                                            align-items-center
                                                                            justify-content-center
                                                                        "
                                                                    >
                                                                        {{ x.q3Available }}
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            w-25
                                                                            d-flex
                                                                            align-items-center
                                                                            justify-content-center
                                                                        "
                                                                    >
                                                                        {{ x.q4Available }}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td class="text-center align-middle"  :class="{'bg-table-tr-disabled': x.isMixed, 'bg-table-tr': !x.isMixed}">
                                                                {{ x.q1Available + x.q2Available + x.q3Available + x.q4Available }}
                                                            </td>
                                                            <td class="align-middle"  :class="{'bg-table-tr-disabled': x.isMixed, 'bg-table-tr': !x.isMixed}">
                                                                {{ formatCurrency(x.unitCost) }}
                                                            </td>
                                                            <td class="align-middle"  :class="{'bg-table-tr-disabled': x.isMixed, 'bg-table-tr': !x.isMixed}">
                                                                {{ formatCurrency(x.totalAmount) }}
                                                                <div class="text-warning" v-if="x.totalInflation > 0">
                                                                    <small>Inflation: {{formatCurrency(x.totalInflation)}}</small>
                                                                </div>
                                                            </td>
                                                            <!-- <td
                                                                v-if="singleSelection"
                                                                class="
                                                                    align-middle
                                                                    text-center
                                                                "
                                                            >
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                        text-success
                                                                        cursor-pointer
                                                                    "
                                                                    @click="
                                                                        addToCart([x])
                                                                    "
                                                                >
                                                                    <i
                                                                        class="
                                                                            bx bx-cart
                                                                            me-1
                                                                        "
                                                                    ></i
                                                                    >Add to Cart
                                                                </div>
                                                            </td> -->
                                                        </tr>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </b-tab>
            <b-tab @click="refreshData(1)">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span
                        class="d-none d-sm-inline-block position-relative me-2"
                        >Purchase Request Cart
                        <small
                            ><span
                                class="
                                    badge
                                    bg-danger
                                    position-absolute
                                    py-1
                                    ms-1
                                "
                                style="top: -2px"
                                v-if="cartCount > 0"
                                >{{ cartCount }}</span
                            ></small
                        ></span
                    >
                </template>
                <div class="row">
                    <div class="col-xl-8">
                        <div class="card">
                            <div class="card-body">
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <h5 class="mb-0">
                                            Purchase Request Cart
                                        </h5>
                                        <small>List of items in cart</small>
                                    </div>
                                    <div
                                        class="
                                            col-md-6
                                            d-flex
                                            justify-content-end
                                        "
                                    >
                                        <div
                                            id="tickets-table_filter"
                                            class="dataTables_filter me-1"
                                        >
                                            <label
                                                class="
                                                    d-inline-flex
                                                    align-items-center
                                                "
                                            >
                                                <b-form-input
                                                    autocomplete="off"
                                                    v-model="filterCartItems"
                                                    type="search"
                                                    placeholder="Search Items..."
                                                    class="form-control"
                                                ></b-form-input>
                                            </label>
                                        </div>
                                        <div
                                            id="tickets-table_length"
                                            class="dataTables_length"
                                        >
                                            <label
                                                class="
                                                    d-inline-flex
                                                    align-items-center
                                                    mb-0
                                                "
                                            >
                                                <b-form-select
                                                    class="form-select"
                                                    v-model="perPageItem"
                                                    size="sm"
                                                    :options="pageOptions"
                                                ></b-form-select>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive overflow-x-auto">
                                    <table
                                        class="
                                            table
                                            align-middle
                                            mb-0
                                        "
                                    >
                                        <thead class="table-light">
                                            <tr>
                                                <th>Product Desc</th>
                                                <th width="150px">Price</th>
                                                <th width="150px">Quantity</th>
                                                <th colspan="2">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="filteredCartItems.length > 0 && !cartBusy">
                                                <tr
                                                    v-for="x in filteredCartItems"
                                                    :key="x.id"
                                                    @drop="onDropZone($event, x, 'cart')"
                                                    @dragenter.prevent
                                                    @dragover.prevent
                                                >
                                                    <td class="position-relative">
                                                        <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                                                        <h5
                                                            class="font-size-14 mb-0 text-white" 
                                                            :class="{'grab-cursor': !x.withChild}" 
                                                            @mousedown="handleMouseDown($event, x)" 
                                                            @mouseup="handleMouseUp($event, x)"
                                                        >
                                                            {{x.itemName}}
                                                        </h5>
                                                        <p class="mb-0">
                                                            <span>{{ x.description }}</span>
                                                        </p>
                                                        <div v-if="x.withChild"><small><a href="javascript:void(0);" @click="viewConsolidatedItems(x.id, 'cart')">(View consolidated items)</a></small></div>
                                                    </td>
                                                    <td>
                                                        {{
                                                            formatCurrency(
                                                                x.unitCost
                                                            )
                                                        }}
                                                    </td>
                                                    <td>
                                                        <span
                                                            @click="openPopOver(x)"
                                                            class="form-control cursor-pointer"
                                                            :id="`editQ-${x.id}`"
                                                        >
                                                            {{ x.quantity}}
                                                        </span>
                                                        <b-popover
                                                            :show.sync="x.editQty"
                                                            :target="`editQ-${x.id}`"
                                                            :custom-class="x.submitError ? 'custom error' : 'custom'"
                                                            triggers="click blur"
                                                            placement="leftbottom"
                                                            @shown="onShownPopOver(x)"
                                                        >
                                                            <template
                                                                v-slot:title
                                                            >
                                                                <small
                                                                    v-if="x.submitError"
                                                                    class="position-absolute text-white error-message px-1"
                                                                >
                                                                    Quantity must not exceed the max Quantity
                                                                </small>
                                                                <div class="d-flex align-items-center justify-content-between">
                                                                    <small>Edit Quantity</small>
                                                                    <span
                                                                        class="
                                                                            bx
                                                                            bx-x
                                                                            font-size-14
                                                                            cursor-pointer
                                                                        "
                                                                        @click="
                                                                            hidePopOver(
                                                                                x
                                                                            )
                                                                        "
                                                                    ></span>
                                                                </div>
                                                            </template>
                                                            <div class="mb-3">
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >January</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Jan
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Jan >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.JanValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.JanValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.JanValue <=
                                                                                        cartVariables.JanMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.JanValue >
                                                                                        cartVariables.JanMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.JanValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.JanMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >February</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Feb
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Feb >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.FebValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.FebValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.FebValue <=
                                                                                        cartVariables.FebMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.FebValue >
                                                                                        cartVariables.FebMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.FebValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.FebMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >March</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Mar
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Mar >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.MarValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.MarValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.MarValue <=
                                                                                        cartVariables.MarMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.MarValue >
                                                                                        cartVariables.MarMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.MarValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.MarMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        mt-1
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >April</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Apr
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Apr >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.AprValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.AprValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.AprValue <=
                                                                                        cartVariables.AprMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.AprValue >
                                                                                        cartVariables.AprMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.AprValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.AprMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >May</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.May
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.May >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.MayValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.MayValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.MayValue <=
                                                                                        cartVariables.MayMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.MayValue >
                                                                                        cartVariables.MayMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.MayValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.MayMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >June</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.June
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.June >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.JuneValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.JuneValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.JuneValue <=
                                                                                        cartVariables.JuneMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.JuneValue >
                                                                                        cartVariables.JuneMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.JuneValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.JuneMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        mt-1
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >July</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.July
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.July >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.JulyValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.JulyValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.JulyValue <=
                                                                                        cartVariables.JulyMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.JulyValue >
                                                                                        cartVariables.JulyMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.JulyValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.JulyMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >August</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Aug
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Aug >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.AugValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.AugValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.AugValue <=
                                                                                        cartVariables.AugMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.AugValue >
                                                                                        cartVariables.AugMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.AugValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.AugMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >September</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Sep
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Sep >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.SepValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.SepValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.SepValue <=
                                                                                        cartVariables.SepMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.SepValue >
                                                                                        cartVariables.SepMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.SepValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.SepMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        mt-1
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >October</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Oct
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Oct >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.OctValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.OctValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.OctValue <=
                                                                                        cartVariables.OctMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.OctValue >
                                                                                        cartVariables.OctMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.OctValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.OctMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >November</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Nov
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Nov >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.NovValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.NovValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.NovValue <=
                                                                                        cartVariables.NovMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.NovValue >
                                                                                        cartVariables.NovMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.NovValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.NovMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >December</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Dec
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Dec >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.DecValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.DecValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.DecValue <=
                                                                                        cartVariables.DecMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.DecValue >
                                                                                        cartVariables.DecMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.DecValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.DecMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="
                                                                    text-right
                                                                "
                                                            >
                                                                <button
                                                                    type="button"
                                                                    class="
                                                                        btn
                                                                        btn-success
                                                                        btn-sm
                                                                        me-2
                                                                    "
                                                                    @click="
                                                                        saveCartItem(
                                                                            x
                                                                        )
                                                                    "
                                                                >
                                                                    Save
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    class="
                                                                        btn
                                                                        btn-link
                                                                        btn-sm
                                                                    "
                                                                    @click="
                                                                        hidePopOver(
                                                                            x
                                                                        )
                                                                    "
                                                                    :ref="`po-${x.id}`"
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        </b-popover>
                                                    </td>
                                                    <td style="width: 150px">
                                                        {{
                                                            formatCurrency(
                                                                x.total
                                                            )
                                                        }}
                                                    </td>
                                                    <td style="width: 70px">
                                                        <!-- <a
                                                            href="javascript:void(0);"
                                                            class="
                                                                action-icon
                                                                text-primary
                                                            "
                                                            @click="
                                                                updateDescription(
                                                                    x, 'submit'
                                                                )
                                                            "
                                                            ><i
                                                                class="
                                                                    mdi
                                                                    mdi-content-save-edit-outline
                                                                    font-size-18
                                                                "
                                                            ></i
                                                        ></a> -->
                                                        <a
                                                            href="javascript:void(0);"
                                                            class="
                                                                action-icon
                                                                text-danger
                                                            "
                                                            @click="
                                                                deleteCartItem(
                                                                    x, 'submit'
                                                                )
                                                            "
                                                            ><i
                                                                class="
                                                                    mdi
                                                                    mdi-trash-can
                                                                    font-size-18
                                                                "
                                                            ></i
                                                        ></a>
                                                    </td>
                                                </tr>
                                            </template>
                                            <tr
                                                v-if="
                                                    filteredCartItems.length ==
                                                        0 &&
                                                    filterCartItems &&
                                                    !cartBusy
                                                "
                                            >
                                                <td
                                                    colspan="5"
                                                    class="text-center"
                                                >
                                                    Search not found
                                                </td>
                                            </tr>
                                            <tr
                                                v-if="
                                                    filteredCartItems.length ==
                                                        0 &&
                                                    !filterCartItems &&
                                                    !cartBusy
                                                "
                                            >
                                                <td
                                                    colspan="5"
                                                    class="text-center"
                                                >
                                                    No Cart Items found
                                                </td>
                                            </tr>
                                            <tr v-if="cartBusy">
                                                <td
                                                    colspan="5"
                                                    class="text-center"
                                                >
                                                    <div
                                                        class="
                                                            d-flex
                                                            justify-content-center
                                                            align-items-center
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                preloader-component
                                                                me-2
                                                            "
                                                        >
                                                            <div class="status">
                                                                <div
                                                                    class="
                                                                        spinner-chase
                                                                        w-20px
                                                                        h-20px
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <strong
                                                            >Loading...</strong
                                                        >
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="row mb-2">
                                    <div class="col mb-1 mt-4">
                                        <div
                                            class="
                                                dataTables_paginate
                                                paging_simple_numbers
                                                float-end
                                            "
                                        >
                                            <ul
                                                class="
                                                    pagination
                                                    pagination-rounded
                                                    mb-0
                                                "
                                            >
                                                <!-- pagination -->
                                                <b-pagination
                                                    v-model="currentPageItem"
                                                    :total-rows="rowsCartItems"
                                                    :per-page="perPageItem"
                                                ></b-pagination>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4">
                        <form @submit.prevent="checkOut">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title mb-4">
                                        Purchase Request Purpose/Project Name
                                    </h5>
                                    <div>
                                        <textarea
                                            rows="5"
                                            placeholder="Purchase Request Description"
                                            class="form-control"
                                            v-model="pr.description"
                                            :class="{
                                                'is-invalid':
                                                    $v.pr.description.$error,
                                            }"
                                        >
                                        </textarea>
                                        <div
                                            v-if="$v.pr.description.$error"
                                            class="invalid-feedback"
                                        >
                                            <span
                                                v-if="
                                                    !$v.pr.description.required
                                                "
                                                >This value is required.</span
                                            >
                                        </div>
                                    </div>
                                    <div class="mt-2">
                                        <label for="">End User Name</label>
                                        <b-input-group>
                                            <template
                                                #append
                                            >
                                                <b-button
                                                    @click="
                                                        selectUser('submit')
                                                    "
                                                    variant="outline-info"
                                                    ><i
                                                        class="
                                                            mdi
                                                            mdi-clipboard-text-search-outline
                                                        "
                                                    ></i
                                                ></b-button>
                                            </template>
                                            <input
                                                type="text"
                                                placeholder="End User Name"
                                                class="form-control"
                                                v-model="pr.endUserName"
                                                :class="{
                                                    'is-invalid':
                                                        $v.pr.endUserName.$error,
                                                }"
                                                disabled
                                            />
                                        </b-input-group>
                                        <div
                                            v-if="$v.pr.endUserName.$error"
                                            class="invalid-feedback"
                                        >
                                            <span
                                                v-if="
                                                    !$v.pr.endUserName.required
                                                "
                                                >This value is required.</span
                                            >
                                        </div>
                                    </div>
                                    <div class="mt-2">
                                        <label for="">Delivery Location</label>
                                        <input
                                            type="text"
                                            placeholder="Delivery Location"
                                            class="form-control"
                                            v-model="pr.deliveryLocation"
                                            :class="{
                                                'is-invalid':
                                                    $v.pr.deliveryLocation.$error,
                                            }"
                                        />
                                        <div
                                            v-if="$v.pr.deliveryLocation.$error"
                                            class="invalid-feedback"
                                        >
                                            <span
                                                v-if="
                                                    !$v.pr.deliveryLocation.required
                                                "
                                                >This value is required.</span
                                            >
                                        </div>
                                    </div>
                                    <div class="mt-2">
                                        <label for="">Delivery Period</label>
                                        <b-input-group>
                                            <masked-input
                                                id="deliveryPeriod"
                                                type="text"
                                                v-model="pr.deliveryPeriod"
                                                placeholder="Enter Delivery Period..."
                                                class="form-control"
                                                :mask="currencyMask"
                                                autocomplete="off"
                                                :class="{
                                                    'is-invalid':
                                                        $v.pr.deliveryPeriod.$error,
                                                }"
                                            ></masked-input>
                                            <div class="input-group-append" style="width:calc(50% - 80px)">
                                                <span class="form-control">calendar day(s)</span>
                                            </div>
                                        </b-input-group>
                                        <div
                                            v-if="$v.pr.deliveryPeriod.$error"
                                            class="invalid-feedback"
                                        >
                                            <span
                                                v-if="
                                                    !$v.pr.deliveryPeriod.required
                                                "
                                                >This value is required.</span
                                            >
                                        </div>
                                    </div>
                                    <div class="mt-3" v-if="this.pr.id > 0">
                                        <button type="button" class="btn btn-outline-purple btn-block" @click="addAttachment"><i class="bx bx-paperclip"></i> Add Attachments ({{attachmentCount}})</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title mb-3">
                                        Purchase Request Summary
                                    </h4>
                                    <div
                                        class="table-responsive overflow-x-auto"
                                    >
                                        <table class="table mb-0">
                                            <tbody>
                                                <!-- <tr>
                                                    <td>Grand Total :</td>
                                                    <td>
                                                        {{
                                                            formatCurrency(
                                                                totalCartAmt()
                                                            )
                                                        }}
                                                    </td>
                                                </tr> -->
                                                <tr>
                                                    <th>Total :</th>
                                                    <th>
                                                        {{
                                                            formatCurrency(
                                                                totalCartAmt()
                                                            )
                                                        }}
                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <button
                                            type="submit"
                                            class="btn btn-success btn-block"
                                        >
                                            <i
                                                class="
                                                    mdi mdi-cart-arrow-right
                                                    me-1
                                                "
                                            ></i>
                                            Post PR
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </b-tab>
            <b-tab @click="refreshData(2)">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Purchase Requests</span
                    >
                </template>
                <b-tabs
                    pills
                    vertical
                    nav-class="p-0"
                    nav-wrapper-class="col-sm-2"
                    content-class="pt-0 px-2 text-muted"
                    v-model="pillsIndex"
                >
                    <b-tab title-item-class="mb-2">
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="bx bx-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block"
                                >Posted (<template v-if="!prBusy">{{
                                    posted.length
                                }}</template
                                ><template v-if="prBusy"
                                    ><b-spinner
                                        type="grow"
                                        class="wh-10p"
                                        variant="success"
                                        role="status"
                                    ></b-spinner></template
                                >)</span
                            >
                        </template>
                        <div class="card">
                            <div class="card-body bg-primary bg-soft">
                                <div
                                    class="
                                        d-flex
                                        align-items-center
                                        justify-content-between
                                        mb-3
                                    "
                                >
                                    <div>
                                        <h4 class="card-title mb-0">
                                            Posted Purchase Requests
                                        </h4>
                                        <p class="card-title-desc mb-0">
                                            List of posted Purchase Requests
                                        </p>
                                    </div>
                                    <div>
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filterPosted"
                                            type="search"
                                            placeholder="Search P.R..."
                                            class="form-control"
                                        ></b-form-input>
                                    </div>
                                </div>
                                <div
                                    v-if="posted.length == 0"
                                    class="text-center"
                                >
                                    <h5>No data available</h5>
                                </div>
                                <div
                                    v-if="
                                        filterPosted &&
                                        filteredPosted.length == 0
                                    "
                                    class="text-center"
                                >
                                    <h5>Search Not Found</h5>
                                </div>
                                <template v-if="posted.length > 0">
                                    <div
                                        role="tablist"
                                        v-for="x in filteredPosted"
                                        :key="x.id"
                                    >
                                        <b-card
                                            no-body
                                            class="mb-1 shadow-none"
                                        >
                                            <b-card-header
                                                header-tag="header"
                                                role="tab"
                                                class="
                                                    d-flex
                                                    justify-content-between
                                                    align-items-center
                                                "
                                            >
                                                <h6 class="m-0">
                                                    <a
                                                        @click="getPrItems(x)"
                                                        class="text-dark"
                                                        href="javascript: void(0);"
                                                        >[{{
                                                            x.prNumber
                                                        }}]:&nbsp;{{
                                                            x.description
                                                        }}</a
                                                    >
                                                    <a href="javascript:void(0);" style="vertical-align:text-top;" class="bx bx-edit font-size-16 d-inline" title="Edit Description" @click="updatePRDescription(x, 'posted')"></a>
                                                </h6>
                                                <div style="width:300px;" class="text-right">
                                                    <button
                                                        type="button"
                                                        class="
                                                            btn btn-secondary btn-sm me-2
                                                        "
                                                        @click="getPRLogs(x.id)"
                                                    >
                                                        <i
                                                            class="
                                                                bx
                                                                bxs-receipt
                                                                me-1
                                                            "
                                                        ></i
                                                        >PR Logs
                                                    </button>
                                                    <button
                                                        type="button"
                                                        class="
                                                            btn btn-purple btn-sm
                                                        "
                                                        @click="printPR(x.id)"
                                                    >
                                                        <i
                                                            class="
                                                                bx
                                                                bxs-printer
                                                                me-1
                                                            "
                                                        ></i
                                                        >Print Purchase Request
                                                    </button>
                                                </div>
                                            </b-card-header>
                                            <b-collapse
                                                :visible="x.visible"
                                                :accordion="`posted-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <b-card-body
                                                    class="border px-3 py-2"
                                                >
                                                    <div class="mb-3">
                                                        <div
                                                            class="
                                                                d-flex
                                                                justify-content-between
                                                                align-items-center
                                                            "
                                                        >
                                                            <a
                                                                href="javascript:void(0);"
                                                                @click="
                                                                    getAttachments(
                                                                        x
                                                                    )
                                                                "
                                                            >
                                                                <i
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                    "
                                                                >
                                                                    <i
                                                                        class="
                                                                            bx
                                                                            bx-paperclip
                                                                            me-1
                                                                        "
                                                                    ></i>
                                                                    <span
                                                                        class="
                                                                            me-1
                                                                        "
                                                                        >Attachments</span
                                                                    >
                                                                    <i
                                                                        class="
                                                                            bx
                                                                            bx-play
                                                                            me-1
                                                                            font-size-15
                                                                            rotate
                                                                        "
                                                                        :class="{
                                                                            'rotate-90':
                                                                                x.showAttachments,
                                                                        }"
                                                                    ></i>
                                                                </i>
                                                            </a>
                                                            <div class="d-flex">
                                                                <input
                                                                    v-if="
                                                                        x
                                                                            .attachments
                                                                            .length >
                                                                            0 &&
                                                                        x.showAttachments
                                                                    "
                                                                    type="text"
                                                                    class="
                                                                        form-control
                                                                        form-control-sm
                                                                    "
                                                                    v-model="
                                                                        x.fileSearch
                                                                    "
                                                                    @input="
                                                                        searchDocu(
                                                                            x
                                                                        )
                                                                    "
                                                                    placeholder="Search Documents..."
                                                                />
                                                            </div>
                                                        </div>
                                                        <b-collapse
                                                            :visible="
                                                                x.showAttachments
                                                            "
                                                            :accordion="`posted-attachment-accordion-${x.id}`"
                                                            role="tabpanel"
                                                        >
                                                            <div class="mt-2">
                                                                <b-row>
                                                                    <b-col
                                                                        sm="3"
                                                                        v-for="y in searchDocu(
                                                                            x
                                                                        )"
                                                                        :key="
                                                                            y.id
                                                                        "
                                                                        class="
                                                                            mb-2
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                position-relative
                                                                                cursor-pointer
                                                                            "
                                                                            style="
                                                                                z-index: 10;
                                                                            "
                                                                            @click="
                                                                                openDocument(
                                                                                    y
                                                                                )
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    border
                                                                                    p-3
                                                                                "
                                                                            >
                                                                                <div>
                                                                                    <div
                                                                                        class="
                                                                                            float-end
                                                                                            ms-2
                                                                                        "
                                                                                    >
                                                                                        <b-dropdown
                                                                                            id="dropdown-dropleft"
                                                                                            right
                                                                                            variant="link"
                                                                                            toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                                            menu-class="dropdown-menu-end"
                                                                                            no-caret
                                                                                        >
                                                                                            <template
                                                                                                #button-content
                                                                                            >
                                                                                                <i
                                                                                                    class="
                                                                                                        mdi
                                                                                                        mdi-dots-horizontal
                                                                                                    "
                                                                                                ></i>
                                                                                            </template>
                                                                                            <b-dropdown-item
                                                                                                @click="
                                                                                                    openDocument(
                                                                                                        y
                                                                                                    )
                                                                                                "
                                                                                                ><i
                                                                                                    class="
                                                                                                        bx
                                                                                                        bx-link-external
                                                                                                        me-1
                                                                                                    "
                                                                                                ></i
                                                                                                >Open</b-dropdown-item
                                                                                            >
                                                                                        </b-dropdown>
                                                                                    </div>
                                                                                    <div
                                                                                        class="
                                                                                            avatar-xs
                                                                                            me-3
                                                                                            mb-2
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            class="
                                                                                                avatar-title
                                                                                                bg-transparent
                                                                                                rounded
                                                                                            "
                                                                                        >
                                                                                            <i
                                                                                                v-if="
                                                                                                    y.fileType.includes(
                                                                                                        'image'
                                                                                                    )
                                                                                                "
                                                                                                class="
                                                                                                    mdi
                                                                                                    mdi-image
                                                                                                    font-size-24
                                                                                                    text-purple
                                                                                                "
                                                                                            ></i>
                                                                                            <i
                                                                                                v-if="
                                                                                                    y.fileType.includes(
                                                                                                        'application'
                                                                                                    )
                                                                                                "
                                                                                                class="
                                                                                                    mdi
                                                                                                    mdi-file-pdf-outline
                                                                                                    font-size-24
                                                                                                    text-danger
                                                                                                "
                                                                                            ></i>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        class="
                                                                                            d-flex
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            class="
                                                                                                overflow-hidden
                                                                                                me-auto
                                                                                            "
                                                                                        >
                                                                                            <h5
                                                                                                class="
                                                                                                    font-size-14
                                                                                                    text-truncate
                                                                                                    mb-1
                                                                                                "
                                                                                            >
                                                                                                {{
                                                                                                    y.description
                                                                                                }}
                                                                                            </h5>
                                                                                            <p
                                                                                                class="
                                                                                                    text-muted
                                                                                                    mb-0
                                                                                                "
                                                                                            >
                                                                                                {{
                                                                                                    formatDateWithTime(
                                                                                                        new Date(
                                                                                                            y.dateTimeUploaded
                                                                                                        )
                                                                                                    )
                                                                                                }}
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </b-col>
                                                                </b-row>
                                                                <b-row
                                                                    v-if="
                                                                        x.attachments >
                                                                            0 &&
                                                                        searchDocu(
                                                                            x
                                                                        )
                                                                            .length ==
                                                                            0
                                                                    "
                                                                >
                                                                    <b-col
                                                                        >Search
                                                                        Not
                                                                        Found</b-col
                                                                    >
                                                                </b-row>
                                                                <p
                                                                    class="
                                                                        mb-0
                                                                        text-warning
                                                                    "
                                                                    v-if="
                                                                        !x.attachmentLoading &&
                                                                        x
                                                                            .attachments
                                                                            .length ==
                                                                            0
                                                                    "
                                                                >
                                                                    <i
                                                                        >No
                                                                        documents
                                                                        found</i
                                                                    >
                                                                </p>
                                                                <div
                                                                    v-if="
                                                                        x.attachmentLoading
                                                                    "
                                                                    class="
                                                                        d-flex
                                                                        justify-content-center
                                                                        align-items-center
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            preloader-component
                                                                            me-2
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                status
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    spinner-chase
                                                                                    w-20px
                                                                                    h-20px
                                                                                "
                                                                            >
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <strong
                                                                        >Loading...</strong
                                                                    >
                                                                </div>
                                                            </div>
                                                        </b-collapse>
                                                    </div>
                                                    <div
                                                        class="
                                                            border
                                                            border-secondary
                                                            position-relative
                                                            mb-3
                                                            p-3
                                                        "
                                                    >
                                                        <div class="isCatchup">
                                                            <i>List of Items</i>
                                                        </div>
                                                        <div
                                                            v-if="
                                                                !x.itemLoaded &&
                                                                x.itemLoading
                                                            "
                                                        >
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    justify-content-center
                                                                    align-items-center
                                                                "
                                                            >
                                                                <div
                                                                    class="
                                                                        preloader-component
                                                                        me-2
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            status
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                spinner-chase
                                                                                w-20px
                                                                                h-20px
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                            <div
                                                                                class="
                                                                                    chase-dot
                                                                                "
                                                                            ></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <strong
                                                                    >Loading...</strong
                                                                >
                                                            </div>
                                                        </div>
                                                        <div
                                                            v-if="
                                                                x.itemLoaded &&
                                                                x.prItems
                                                                    .length == 0
                                                            "
                                                            class="text-center"
                                                        >
                                                            No items found
                                                        </div>
                                                        <table
                                                            width="100%"
                                                            v-if="x.prItems.length > 0"
                                                            class="striped-translucent"
                                                        >
                                                            <tr
                                                                v-for="y in x.prItems"
                                                                :key="y.id"
                                                            >
                                                                <td class="p-1">
                                                                    {{ y.quantity }} x
                                                                    {{ y.itemName }}
                                                                </td>
                                                                <td style="width: 160px;" class="p-1">
                                                                    {{ formatCurrency(y.unitCost) }}
                                                                </td>
                                                                <td style="width: 160px;" class="p-1">
                                                                    {{ formatCurrency(y.total) }}
                                                                </td>
                                                            </tr>
                                                            <tr class="border border-dashed">
                                                                <td class="py-2"></td>
                                                                <td class="text-right py-2 px-2">Total:</td>
                                                                <td colspan="3" class="py-2">{{ formatCurrency(getTotalPerPR(x.prItems)) }}</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </b-card-body>
                                            </b-collapse>
                                        </b-card>
                                    </div>
                                </template>
                                <div
                                    class="text-right"
                                    v-if="posted.length > 0"
                                >
                                    <ul
                                        class="
                                            pagination
                                            justify-content-end
                                            px-2
                                            mb-0
                                            mt-3
                                        "
                                        style="z-index: -1"
                                    >
                                        <b-pagination
                                            size="sm"
                                            v-model="currentPagePR"
                                            :total-rows="rowsPosted"
                                            :per-page="perPagePR"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title-item-class="mb-2">
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="bx bx-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block"
                                >Approved (<template v-if="!prBusy">{{
                                    approved.length
                                }}</template
                                ><template v-if="prBusy"
                                    ><b-spinner
                                        type="grow"
                                        class="wh-10p"
                                        variant="success"
                                        role="status"
                                    ></b-spinner></template
                                >)</span
                            >
                        </template>
                        <div class="card">
                            <div class="card-body bg-success bg-soft">
                                <div
                                    class="
                                        d-flex
                                        align-items-center
                                        justify-content-between
                                        mb-3
                                    "
                                >
                                    <div>
                                        <h4 class="card-title mb-0">
                                            Approved Purchase Requests
                                        </h4>
                                        <p class="card-title-desc mb-0">
                                            List of approved Purchase Requests
                                        </p>
                                    </div>
                                    <div>
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filterApproved"
                                            type="search"
                                            placeholder="Search P.R..."
                                            class="form-control"
                                        ></b-form-input>
                                    </div>
                                </div>
                                <div
                                    v-if="approved.length == 0"
                                    class="text-center"
                                >
                                    <h5>No data available</h5>
                                </div>
                                <div
                                    v-if="
                                        filterApproved &&
                                        filteredApproved.length == 0
                                    "
                                    class="text-center"
                                >
                                    <h5>Search Not Found</h5>
                                </div>
                                <template v-if="approved.length > 0">
                                    <div
                                        role="tablist"
                                        v-for="x in filteredApproved"
                                        :key="x.id"
                                        :ref="`card-pr-${x.id}`"
                                    >
                                        <b-card
                                            no-body
                                            class="mb-1 shadow-none"
                                        >
                                            <b-card-header
                                                header-tag="header"
                                                role="tab"
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    justify-content-between
                                                "
                                            >
                                                <h6 class="m-0">
                                                    <a
                                                        @click="getPrItems(x)"
                                                        class="text-dark d-inline"
                                                        href="javascript: void(0);"
                                                        >[{{
                                                            x.prNumber
                                                        }}]:&nbsp;{{
                                                            x.description
                                                        }}</a
                                                    >
                                                    <a href="javascript:void(0);" style="vertical-align:text-top;" class="bx bx-edit font-size-16 d-inline ms-1" title="Edit Description" @click="updatePRDescription(x, 'approved')"></a>
                                                </h6>
                                                <div style="width:300px;" class="text-right">
                                                    <button
                                                        type="button"
                                                        class="
                                                            btn btn-secondary btn-sm me-2
                                                        "
                                                        @click="getPRLogs(x.id)"
                                                    >
                                                        <i
                                                            class="
                                                                bx
                                                                bxs-receipt
                                                                me-1
                                                            "
                                                        ></i
                                                        >PR Logs
                                                    </button>
                                                    <button
                                                        type="button"
                                                        class="
                                                            btn btn-purple btn-sm
                                                        "
                                                        @click="printPR(x.id)"
                                                    >
                                                        <i
                                                            class="
                                                                bx
                                                                bxs-printer
                                                                me-1
                                                            "
                                                        ></i
                                                        >Print Purchase Request
                                                    </button>
                                                </div>
                                            </b-card-header>
                                            <b-collapse
                                                :visible="x.visible"
                                                :accordion="`posted-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <b-card-body
                                                    class="border px-3 py-2"
                                                >
                                                    <div class="mb-3">
                                                        <div class="text-right">
                                                            <button
                                                                v-if="x.visible && $store.state.decrypt.isAdmin()"
                                                                @click="updatePR(x)"
                                                                type="button"
                                                                class="
                                                                    btn
                                                                    btn-sm
                                                                    btn-success
                                                                    me-2
                                                                "
                                                            >
                                                                <i
                                                                    class="
                                                                        bx bx-edit
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >Update Item
                                                            </button>
                                                        </div>
                                                        <div
                                                            class="
                                                                d-flex
                                                                justify-content-between
                                                                align-items-center
                                                            "
                                                        >
                                                            <a
                                                                href="javascript:void(0);"
                                                                @click="
                                                                    getAttachments(
                                                                        x
                                                                    )
                                                                "
                                                            >
                                                                <i
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                    "
                                                                >
                                                                    <i
                                                                        class="
                                                                            bx
                                                                            bx-paperclip
                                                                            me-1
                                                                        "
                                                                    ></i>
                                                                    <span
                                                                        class="
                                                                            me-1
                                                                        "
                                                                        >Attachments</span
                                                                    >
                                                                    <i
                                                                        class="
                                                                            bx
                                                                            bx-play
                                                                            me-1
                                                                            font-size-15
                                                                            rotate
                                                                        "
                                                                        :class="{
                                                                            'rotate-90':
                                                                                x.showAttachments,
                                                                        }"
                                                                    ></i>
                                                                </i>
                                                            </a>
                                                            <div class="d-flex">
                                                                <input
                                                                    v-if="
                                                                        x
                                                                            .attachments
                                                                            .length >
                                                                            0 &&
                                                                        x.showAttachments
                                                                    "
                                                                    type="text"
                                                                    class="
                                                                        form-control
                                                                        form-control-sm
                                                                    "
                                                                    v-model="
                                                                        x.fileSearch
                                                                    "
                                                                    @input="
                                                                        searchDocu(
                                                                            x
                                                                        )
                                                                    "
                                                                    placeholder="Search Documents..."
                                                                />
                                                            </div>
                                                        </div>
                                                        <b-collapse
                                                            :visible="
                                                                x.showAttachments
                                                            "
                                                            :accordion="`posted-attachment-accordion-${x.id}`"
                                                            role="tabpanel"
                                                        >
                                                            <div class="mt-2">
                                                                <b-row>
                                                                    <b-col
                                                                        sm="3"
                                                                        v-for="y in searchDocu(
                                                                            x
                                                                        )"
                                                                        :key="
                                                                            y.id
                                                                        "
                                                                        class="
                                                                            mb-2
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                position-relative
                                                                                cursor-pointer
                                                                            "
                                                                            style="
                                                                                z-index: 10;
                                                                            "
                                                                            @click="
                                                                                openDocument(
                                                                                    y
                                                                                )
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    border
                                                                                    p-3
                                                                                "
                                                                            >
                                                                                <div>
                                                                                    <div
                                                                                        class="
                                                                                            float-end
                                                                                            ms-2
                                                                                        "
                                                                                    >
                                                                                        <b-dropdown
                                                                                            id="dropdown-dropleft"
                                                                                            right
                                                                                            variant="link"
                                                                                            toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                                            menu-class="dropdown-menu-end"
                                                                                            no-caret
                                                                                        >
                                                                                            <template
                                                                                                #button-content
                                                                                            >
                                                                                                <i
                                                                                                    class="
                                                                                                        mdi
                                                                                                        mdi-dots-horizontal
                                                                                                    "
                                                                                                ></i>
                                                                                            </template>
                                                                                            <b-dropdown-item
                                                                                                @click="
                                                                                                    openDocument(
                                                                                                        y
                                                                                                    )
                                                                                                "
                                                                                                ><i
                                                                                                    class="
                                                                                                        bx
                                                                                                        bx-link-external
                                                                                                        me-1
                                                                                                    "
                                                                                                ></i
                                                                                                >Open</b-dropdown-item
                                                                                            >
                                                                                        </b-dropdown>
                                                                                    </div>
                                                                                    <div
                                                                                        class="
                                                                                            avatar-xs
                                                                                            me-3
                                                                                            mb-2
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            class="
                                                                                                avatar-title
                                                                                                bg-transparent
                                                                                                rounded
                                                                                            "
                                                                                        >
                                                                                            <i
                                                                                                v-if="
                                                                                                    y.fileType.includes(
                                                                                                        'image'
                                                                                                    )
                                                                                                "
                                                                                                class="
                                                                                                    mdi
                                                                                                    mdi-image
                                                                                                    font-size-24
                                                                                                    text-purple
                                                                                                "
                                                                                            ></i>
                                                                                            <i
                                                                                                v-if="
                                                                                                    y.fileType.includes(
                                                                                                        'application'
                                                                                                    )
                                                                                                "
                                                                                                class="
                                                                                                    mdi
                                                                                                    mdi-file-pdf-outline
                                                                                                    font-size-24
                                                                                                    text-danger
                                                                                                "
                                                                                            ></i>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        class="
                                                                                            d-flex
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            class="
                                                                                                overflow-hidden
                                                                                                me-auto
                                                                                            "
                                                                                        >
                                                                                            <h5
                                                                                                class="
                                                                                                    font-size-14
                                                                                                    text-truncate
                                                                                                    mb-1
                                                                                                "
                                                                                            >
                                                                                                {{
                                                                                                    y.description
                                                                                                }}
                                                                                            </h5>
                                                                                            <p
                                                                                                class="
                                                                                                    text-muted
                                                                                                    mb-0
                                                                                                "
                                                                                            >
                                                                                                {{
                                                                                                    formatDateWithTime(
                                                                                                        new Date(
                                                                                                            y.dateTimeUploaded
                                                                                                        )
                                                                                                    )
                                                                                                }}
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </b-col>
                                                                </b-row>
                                                                <b-row
                                                                    v-if="
                                                                        x.attachments >
                                                                            0 &&
                                                                        searchDocu(
                                                                            x
                                                                        )
                                                                            .length ==
                                                                            0
                                                                    "
                                                                >
                                                                    <b-col
                                                                        >Search
                                                                        Not
                                                                        Found</b-col
                                                                    >
                                                                </b-row>
                                                                <p
                                                                    class="
                                                                        mb-0
                                                                        text-warning
                                                                    "
                                                                    v-if="
                                                                        !x.attachmentLoading &&
                                                                        x
                                                                            .attachments
                                                                            .length ==
                                                                            0
                                                                    "
                                                                >
                                                                    <i
                                                                        >No
                                                                        documents
                                                                        found</i
                                                                    >
                                                                </p>
                                                                <div
                                                                    v-if="
                                                                        x.attachmentLoading
                                                                    "
                                                                    class="
                                                                        d-flex
                                                                        justify-content-center
                                                                        align-items-center
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            preloader-component
                                                                            me-2
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                status
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    spinner-chase
                                                                                    w-20px
                                                                                    h-20px
                                                                                "
                                                                            >
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <strong
                                                                        >Loading...</strong
                                                                    >
                                                                </div>
                                                            </div>
                                                        </b-collapse>
                                                    </div>
                                                    <div
                                                        class="
                                                            border
                                                            border-secondary
                                                            position-relative
                                                            mb-3
                                                            p-3
                                                        "
                                                    >
                                                        <div class="isCatchup">
                                                            <i>List of Items</i>
                                                        </div>
                                                        <div
                                                            class="
                                                                d-flex
                                                                justify-content-center
                                                                align-items-center
                                                            "
                                                            v-if="
                                                                !x.itemLoaded &&
                                                                x.itemLoading
                                                            "
                                                        >
                                                            <div
                                                                class="
                                                                    preloader-component
                                                                    me-2
                                                                "
                                                            >
                                                                <div
                                                                    class="
                                                                        status
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            spinner-chase
                                                                            w-20px
                                                                            h-20px
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                        <div
                                                                            class="
                                                                                chase-dot
                                                                            "
                                                                        ></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <strong
                                                                >Loading...</strong
                                                            >
                                                        </div>
                                                        <div
                                                            v-if="
                                                                x.itemLoaded &&
                                                                x.prItems
                                                                    .length == 0
                                                            "
                                                            class="text-center"
                                                        >
                                                            No items found
                                                        </div>
                                                        <table
                                                            width="100%"
                                                            v-if="x.prItems.length > 0"
                                                            class="striped-translucent"
                                                        >
                                                            <tr
                                                                v-for="y in x.prItems"
                                                                :key="y.id"
                                                            >
                                                                <td class="p-1">
                                                                    {{ y.quantity }} x
                                                                    {{ y.itemName }}
                                                                </td>
                                                                <td style="width: 160px;" class="p-1">
                                                                    {{ formatCurrency(y.unitCost) }}
                                                                </td>
                                                                <td style="width: 160px;" class="p-1">
                                                                    {{ formatCurrency(y.total) }}
                                                                </td>
                                                            </tr>
                                                            <tr class="border border-dashed">
                                                                <td class="py-2"></td>
                                                                <td class="text-right py-2 px-2">Total:</td>
                                                                <td colspan="3" class="py-2">{{ formatCurrency(getTotalPerPR(x.prItems)) }}</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </b-card-body>
                                            </b-collapse>
                                        </b-card>
                                    </div>
                                </template>
                                <div
                                    class="text-right"
                                    v-if="approved.length > 0"
                                >
                                    <ul
                                        class="
                                            pagination
                                            justify-content-end
                                            px-2
                                            mb-0
                                            mt-3
                                        "
                                        style="z-index: -1"
                                    >
                                        <b-pagination
                                            size="sm"
                                            v-model="currentPagePR"
                                            :total-rows="rowsApproved"
                                            :per-page="perPagePR"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title-item-class="mb-2">
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="bx bx-home"></i>
                            </span>
                            <span class="d-none d-sm-inline-block"
                                >Returned (<template v-if="!prBusy">{{
                                    returned.length
                                }}</template
                                ><template v-if="prBusy"
                                    ><b-spinner
                                        type="grow"
                                        class="wh-10p"
                                        variant="success"
                                        role="status"
                                    ></b-spinner></template
                                >)</span
                            >
                        </template>
                        <div class="card">
                            <div class="card-body bg-warning bg-soft">
                                <div
                                    class="
                                        d-flex
                                        align-items-center
                                        justify-content-between
                                        mb-3
                                    "
                                >
                                    <div>
                                        <h4 class="card-title mb-0">
                                            Returned Purchase Requests
                                        </h4>
                                        <p class="card-title-desc mb-0">
                                            List of returned Purchase Requests
                                        </p>
                                    </div>
                                    <div>
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filterReturn"
                                            type="search"
                                            placeholder="Search P.R..."
                                            class="form-control"
                                        ></b-form-input>
                                    </div>
                                </div>
                                <div
                                    v-if="returned.length == 0"
                                    class="text-center"
                                >
                                    <h5>No data available</h5>
                                </div>
                                <div
                                    v-if="
                                        filterReturn &&
                                        filteredReturn.length == 0
                                    "
                                    class="text-center"
                                >
                                    <h5>Search Not Found</h5>
                                </div>
                                <template v-if="returned.length > 0">
                                    <div
                                        role="tablist"
                                        v-for="x in filteredReturn"
                                        :key="x.id"
                                    >
                                        <b-card
                                            no-body
                                            class="mb-1 shadow-none"
                                        >
                                            <b-card-header
                                                header-tag="header"
                                                role="tab"
                                            >
                                                <div
                                                    class="
                                                        d-flex
                                                        justify-content-between
                                                        align-items-center
                                                    "
                                                >
                                                    <h6 class="m-0">
                                                        <a
                                                            @click="
                                                                getPrItems(x)
                                                            "
                                                            class="text-dark"
                                                            href="javascript: void(0);"
                                                            >[{{
                                                                x.prNumber
                                                            }}]:&nbsp;{{
                                                                x.description
                                                            }}</a
                                                        >
                                                    </h6>
                                                    <div class="d-flex">
                                                        <button
                                                            type="button"
                                                            class="
                                                                btn btn-secondary btn-sm me-2 d-flex text-nowrap
                                                            "
                                                            @click="getPRLogs(x.id)"
                                                        >
                                                            <i
                                                                class="
                                                                    bx
                                                                    bx-receipt
                                                                    me-1
                                                                "
                                                            ></i
                                                            >PR Logs
                                                        </button>
                                                        <button
                                                            @click="updatePR(x)"
                                                            type="button"
                                                            class="
                                                                btn
                                                                btn-sm
                                                                btn-success
                                                                d-flex
                                                                text-nowrap
                                                                me-2
                                                            "
                                                            v-if="x.visible"
                                                        >
                                                            <i
                                                                class="
                                                                    bx bx-edit
                                                                    me-1
                                                                "
                                                            ></i
                                                            >Update Item
                                                        </button>
                                                        <button
                                                            @click="deletePR(x)"
                                                            type="button"
                                                            class="
                                                                btn
                                                                btn-sm
                                                                btn-danger
                                                                d-flex
                                                                text-nowrap
                                                            "
                                                            v-if="x.visible"
                                                        >
                                                            <i
                                                                class="
                                                                    bx bx-trash
                                                                    me-1
                                                                "
                                                            ></i
                                                            >Delete PR
                                                        </button>
                                                    </div>
                                                </div>
                                            </b-card-header>
                                            <b-collapse
                                                :visible="x.visible"
                                                :accordion="`posted-accordion-${x.id}`"
                                                role="tabpanel"
                                            >
                                                <b-card-body
                                                    class="border px-3 py-2"
                                                >
                                                    <div class="mb-3">
                                                        <div
                                                            class="
                                                                d-flex
                                                                justify-content-between
                                                                align-items-center
                                                            "
                                                        >
                                                            <a
                                                                href="javascript:void(0);"
                                                                @click="
                                                                    getAttachments(
                                                                        x
                                                                    )
                                                                "
                                                            >
                                                                <i
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                    "
                                                                >
                                                                    <i
                                                                        class="
                                                                            bx
                                                                            bx-paperclip
                                                                            me-1
                                                                        "
                                                                    ></i>
                                                                    <span
                                                                        class="
                                                                            me-1
                                                                        "
                                                                        >Attachments</span
                                                                    >
                                                                    <i
                                                                        class="
                                                                            bx
                                                                            bx-play
                                                                            me-1
                                                                            font-size-15
                                                                            rotate
                                                                        "
                                                                        :class="{
                                                                            'rotate-90':
                                                                                x.showAttachments,
                                                                        }"
                                                                    ></i>
                                                                </i>
                                                            </a>
                                                            <div class="d-flex">
                                                                <input
                                                                    v-if="
                                                                        x
                                                                            .attachments
                                                                            .length >
                                                                            0 &&
                                                                        x.showAttachments
                                                                    "
                                                                    type="text"
                                                                    class="
                                                                        form-control
                                                                        form-control-sm
                                                                    "
                                                                    v-model="
                                                                        x.fileSearch
                                                                    "
                                                                    @input="
                                                                        searchDocu(
                                                                            x
                                                                        )
                                                                    "
                                                                    placeholder="Search Documents..."
                                                                />
                                                            </div>
                                                        </div>
                                                        <b-collapse
                                                            :visible="
                                                                x.showAttachments
                                                            "
                                                            :accordion="`posted-attachment-accordion-${x.id}`"
                                                            role="tabpanel"
                                                        >
                                                            <div class="mt-2">
                                                                <b-row>
                                                                    <b-col
                                                                        sm="3"
                                                                        v-for="y in searchDocu(
                                                                            x
                                                                        )"
                                                                        :key="
                                                                            y.id
                                                                        "
                                                                        class="
                                                                            mb-2
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                position-relative
                                                                                cursor-pointer
                                                                            "
                                                                            style="
                                                                                z-index: 10;
                                                                            "
                                                                            @click="
                                                                                openDocument(
                                                                                    y
                                                                                )
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    border
                                                                                    p-3
                                                                                "
                                                                            >
                                                                                <div>
                                                                                    <div
                                                                                        class="
                                                                                            float-end
                                                                                            ms-2
                                                                                        "
                                                                                    >
                                                                                        <b-dropdown
                                                                                            id="dropdown-dropleft"
                                                                                            right
                                                                                            variant="link"
                                                                                            toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                                            menu-class="dropdown-menu-end"
                                                                                            no-caret
                                                                                        >
                                                                                            <template
                                                                                                #button-content
                                                                                            >
                                                                                                <i
                                                                                                    class="
                                                                                                        mdi
                                                                                                        mdi-dots-horizontal
                                                                                                    "
                                                                                                ></i>
                                                                                            </template>
                                                                                            <b-dropdown-item
                                                                                                @click="
                                                                                                    openDocument(
                                                                                                        y
                                                                                                    )
                                                                                                "
                                                                                                ><i
                                                                                                    class="
                                                                                                        bx
                                                                                                        bx-link-external
                                                                                                        me-1
                                                                                                    "
                                                                                                ></i
                                                                                                >Open</b-dropdown-item
                                                                                            >
                                                                                        </b-dropdown>
                                                                                    </div>
                                                                                    <div
                                                                                        class="
                                                                                            avatar-xs
                                                                                            me-3
                                                                                            mb-2
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            class="
                                                                                                avatar-title
                                                                                                bg-transparent
                                                                                                rounded
                                                                                            "
                                                                                        >
                                                                                            <i
                                                                                                v-if="
                                                                                                    y.fileType.includes(
                                                                                                        'image'
                                                                                                    )
                                                                                                "
                                                                                                class="
                                                                                                    mdi
                                                                                                    mdi-image
                                                                                                    font-size-24
                                                                                                    text-purple
                                                                                                "
                                                                                            ></i>
                                                                                            <i
                                                                                                v-if="
                                                                                                    y.fileType.includes(
                                                                                                        'application'
                                                                                                    )
                                                                                                "
                                                                                                class="
                                                                                                    mdi
                                                                                                    mdi-file-pdf-outline
                                                                                                    font-size-24
                                                                                                    text-danger
                                                                                                "
                                                                                            ></i>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        class="
                                                                                            d-flex
                                                                                        "
                                                                                    >
                                                                                        <div
                                                                                            class="
                                                                                                overflow-hidden
                                                                                                me-auto
                                                                                            "
                                                                                        >
                                                                                            <h5
                                                                                                class="
                                                                                                    font-size-14
                                                                                                    text-truncate
                                                                                                    mb-1
                                                                                                "
                                                                                            >
                                                                                                {{
                                                                                                    y.description
                                                                                                }}
                                                                                            </h5>
                                                                                            <p
                                                                                                class="
                                                                                                    text-muted
                                                                                                    mb-0
                                                                                                "
                                                                                            >
                                                                                                {{
                                                                                                    formatDateWithTime(
                                                                                                        new Date(
                                                                                                            y.dateTimeUploaded
                                                                                                        )
                                                                                                    )
                                                                                                }}
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </b-col>
                                                                </b-row>
                                                                <b-row
                                                                    v-if="
                                                                        x.attachments >
                                                                            0 &&
                                                                        searchDocu(
                                                                            x
                                                                        )
                                                                            .length ==
                                                                            0
                                                                    "
                                                                >
                                                                    <b-col
                                                                        >Search
                                                                        Not
                                                                        Found</b-col
                                                                    >
                                                                </b-row>
                                                                <p
                                                                    class="
                                                                        mb-0
                                                                        text-warning
                                                                    "
                                                                    v-if="
                                                                        !x.attachmentLoading &&
                                                                        x
                                                                            .attachments
                                                                            .length ==
                                                                            0
                                                                    "
                                                                >
                                                                    <i
                                                                        >No
                                                                        documents
                                                                        found</i
                                                                    >
                                                                </p>
                                                                <div
                                                                    v-if="
                                                                        x.attachmentLoading
                                                                    "
                                                                    class="
                                                                        d-flex
                                                                        justify-content-center
                                                                        align-items-center
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            preloader-component
                                                                            me-2
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                status
                                                                            "
                                                                        >
                                                                            <div
                                                                                class="
                                                                                    spinner-chase
                                                                                    w-20px
                                                                                    h-20px
                                                                                "
                                                                            >
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                                <div
                                                                                    class="
                                                                                        chase-dot
                                                                                    "
                                                                                ></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <strong
                                                                        >Loading...</strong
                                                                    >
                                                                </div>
                                                            </div>
                                                        </b-collapse>
                                                    </div>
                                                    <div
                                                        class="
                                                            border
                                                            border-secondary
                                                            position-relative
                                                            mb-3
                                                            p-3
                                                        "
                                                    >
                                                        <div class="isCatchup">
                                                            <i>List of Items</i>
                                                        </div>
                                                        <div v-if="!x.itemLoaded && x.itemLoading">
                                                            <div class="d-flex justify-content-center align-items-center">
                                                                <div class="preloader-component me-2">
                                                                    <div class="status">
                                                                        <div class="spinner-chase w-20px h-20px">
                                                                            <div class="chase-dot"></div>
                                                                            <div class="chase-dot"></div>
                                                                            <div class="chase-dot"></div>
                                                                            <div class="chase-dot"></div>
                                                                            <div class="chase-dot"></div>
                                                                            <div class="chase-dot"></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <strong>Loading...</strong>
                                                            </div>
                                                        </div>
                                                        <div
                                                            v-if="
                                                                x.itemLoaded &&
                                                                x.prItems
                                                                    .length == 0
                                                            "
                                                            class="text-center"
                                                        >
                                                            No items found
                                                        </div>
                                                        <table
                                                            width="100%"
                                                            v-if="x.prItems.length > 0"
                                                            class="striped-translucent"
                                                        >
                                                            <tr
                                                                v-for="y in x.prItems"
                                                                :key="y.id"
                                                            >
                                                                <td class="p-1">
                                                                    {{ y.quantity }} x
                                                                    {{ y.itemName }}
                                                                </td>
                                                                <td style="width: 160px;" class="p-1">
                                                                    {{ formatCurrency(y.unitCost) }}
                                                                </td>
                                                                <td style="width: 160px;" class="p-1">
                                                                    {{ formatCurrency(y.total) }}
                                                                </td>
                                                            </tr>
                                                            <tr class="border border-dashed">
                                                                <td class="py-2"></td>
                                                                <td class="text-right py-2 px-2">Total:</td>
                                                                <td colspan="3" class="py-2">{{ formatCurrency(getTotalPerPR(x.prItems)) }}</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </b-card-body>
                                            </b-collapse>
                                        </b-card>
                                    </div>
                                </template>
                                <div
                                    class="text-right"
                                    v-if="returned.length > 0"
                                >
                                    <ul
                                        class="
                                            pagination
                                            justify-content-end
                                            px-2
                                            mb-0
                                            mt-3
                                        "
                                        style="z-index: -1"
                                    >
                                        <b-pagination
                                            size="sm"
                                            v-model="currentPagePR"
                                            :total-rows="rowsReturn"
                                            :per-page="perPagePR"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
            </b-tab>
            <b-tab @click="getReturnedPRItems($store.state.data.selectedDU.id)">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Return Items for Editing (RFQ)</span
                    >
                </template>
                <h5>Item List</h5>
                <div v-for="x in returnedItems" :key="`resourceList-z${x.id}`" class="mb-1 p-3 broken-border" >
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex">
                            <div class="d-flex align-items-center">
                                <div class="font-size-20 text-yellow text-nowrap">
                                    {{x.totalQuantity}} {{x.apiResource.unit && x.apiResource.unit.shortName}}
                                </div>
                                <i class="bx bx-x font-size-20 me-2 text-yellow"></i>
                            </div>
                            <div>
                                <div>
                                    {{x.apiResource.itemName}}
                                    <div>
                                        <small>{{x.apiResource.description}}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <div class="font-size-20 text-yellow mb-0">
                                {{formatCurrency(x.total)}}
                            </div>
                            <div>
                                <small>
                                    ({{formatCurrency(x.apiResource.unitCost)}})
                                </small>
                            </div>
                            <div>
                                <a href="javascript:void(0);" class="btn btn-primary mt-2 btn-sm text-nowrap me-2" @click="updateDescription(x, 'returned')"><i class="bx bx-edit"></i> Update this Resource</a>
                                <a href="javascript:void(0);" class="btn btn-success mt-2 btn-sm text-nowrap" @click="resubmitItem(x)"><i class="bx bx-check"></i> Resubmit item</a>
                            </div>
                        </div>
                    </div>
                    <div class="mt-2">
                        <small>Edit Remarks: <span class="text-warning">{{x.editRemarks}}</span></small>
                    </div>
                </div>
            </b-tab>
            <b-tab v-if="showUpdatePR">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Update PR</span
                    ><i
                        class="bx bx-x ms-5 cursor-pointer"
                        @click="dismissUpdate()"
                    ></i>
                </template>
                <div class="row">
                    <div class="col-xl-8">
                        <div class="card">
                            <div class="card-body">
                                <div class="row mb-2">
                                    <div class="col-md-6">
                                        <h5 class="mb-0">
                                            Returned Purchase Request
                                        </h5>
                                        <small
                                            >List of items in returned Purchase
                                            Request</small
                                        >
                                    </div>
                                    <div
                                        class="
                                            col-md-6
                                            d-flex
                                            justify-content-end
                                        "
                                    >
                                        <div
                                            id="tickets-table_filter"
                                            class="dataTables_filter me-1"
                                        >
                                            <label
                                                class="
                                                    d-inline-flex
                                                    align-items-center
                                                "
                                            >
                                                <b-form-input
                                                    autocomplete="off"
                                                    v-model="filterUpdateItems"
                                                    type="search"
                                                    placeholder="Search Items..."
                                                    class="form-control"
                                                ></b-form-input>
                                            </label>
                                        </div>
                                        <div
                                            id="tickets-table_length"
                                            class="dataTables_length"
                                        >
                                            <label
                                                class="
                                                    d-inline-flex
                                                    align-items-center
                                                    mb-0
                                                "
                                            >
                                                <b-form-select
                                                    class="form-select"
                                                    v-model="perPageUpdate"
                                                    size="sm"
                                                    :options="pageOptions"
                                                ></b-form-select>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive overflow-x-auto">
                                    <table
                                        class="
                                            table
                                            align-middle
                                            mb-0
                                        "
                                    >
                                        <thead class="table-light">
                                            <tr>
                                                <th>Product Desc</th>
                                                <th width="150px">Price</th>
                                                <th width="150px">Quantity</th>
                                                <th colspan="2">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="filteredUpdateItems.length > 0 && !updateBusy">
                                                <tr
                                                    v-for="x in filteredUpdateItems"
                                                    :key="x.id"
                                                    @drop="onDropZone($event, x, 'returned')"
                                                    @dragenter.prevent
                                                    @dragover.prevent
                                                >
                                                    <td class="position-relative">
                                                        <RawData :data="x" />
                                                        <h5
                                                            class="font-size-14 mb-0 text-white" 
                                                            :class="{'grab-cursor': !x.withChild}" 
                                                            @mousedown="handleMouseDown($event, x)" 
                                                            @mouseup="handleMouseUp($event, x)"
                                                        >
                                                            {{x.itemName}}
                                                        </h5>
                                                        <p class="mb-0"><span>{{ x.description }}</span></p>
                                                        <div v-if="x.withChild"><small><a href="javascript:void(0);" @click="viewConsolidatedItems(x.id, 'returned')">(View consolidated items)</a></small></div>
                                                    </td>
                                                    <td>{{formatCurrency(x.unitCost)}}</td>
                                                    <td>
                                                        <span
                                                            @click="openPopOver(x)"
                                                            class="form-control cursor-pointer"
                                                            :id="`editQU-${x.id}`"
                                                        >
                                                            {{x.quantity}}
                                                            <span class="text-warning ms-1">{{x.unit}}</span>
                                                        </span>
                                                        <b-popover
                                                            :show.sync="x.editQty"
                                                            :target="`editQU-${x.id}`"
                                                            :custom-class="x.submitError ? 'custom error' : 'custom'"
                                                            triggers="click blur"
                                                            placement="leftbottom"
                                                            @shown="onShownPopOver(x)"
                                                        >
                                                            <template v-slot:title>
                                                                <small 
                                                                    v-if="x.submitError"
                                                                    class=" position-absolute text-white error-message px-1"
                                                                >
                                                                    Quantity must not exceed the max Quantity
                                                                </small>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                        justify-content-between
                                                                    "
                                                                >
                                                                    <small> Edit Quantity</small>
                                                                    <span class="bx bx-x font-size-14 cursor-pointer" @click="hidePopOver(x)"></span>
                                                                </div>
                                                            </template>
                                                            <div class="mb-3">
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >January</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Jan
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Jan >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.JanValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.JanValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.JanValue <=
                                                                                        cartVariables.JanMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.JanValue >
                                                                                        cartVariables.JanMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.JanValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.JanMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >February</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Feb
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Feb >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.FebValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.FebValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.FebValue <=
                                                                                        cartVariables.FebMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.FebValue >
                                                                                        cartVariables.FebMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.FebValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.FebMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >March</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Mar
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Mar >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.MarValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.MarValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.MarValue <=
                                                                                        cartVariables.MarMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.MarValue >
                                                                                        cartVariables.MarMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.MarValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.MarMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        mt-1
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >April</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Apr
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Apr >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.AprValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.AprValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.AprValue <=
                                                                                        cartVariables.AprMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.AprValue >
                                                                                        cartVariables.AprMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.AprValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.AprMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >May</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.May
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.May >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.MayValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.MayValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.MayValue <=
                                                                                        cartVariables.MayMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.MayValue >
                                                                                        cartVariables.MayMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.MayValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.MayMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >June</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.June
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.June >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.JuneValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.JuneValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.JuneValue <=
                                                                                        cartVariables.JuneMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.JuneValue >
                                                                                        cartVariables.JuneMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.JuneValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.JuneMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        mt-1
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >July</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.July
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.July >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.JulyValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.JulyValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.JulyValue <=
                                                                                        cartVariables.JulyMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.JulyValue >
                                                                                        cartVariables.JulyMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.JulyValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.JulyMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >August</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Aug
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Aug >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.AugValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.AugValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.AugValue <=
                                                                                        cartVariables.AugMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.AugValue >
                                                                                        cartVariables.AugMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.AugValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.AugMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >September</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Sep
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Sep >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.SepValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.SepValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.SepValue <=
                                                                                        cartVariables.SepMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.SepValue >
                                                                                        cartVariables.SepMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.SepValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.SepMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        mt-1
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >October</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Oct
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Oct >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.OctValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.OctValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.OctValue <=
                                                                                        cartVariables.OctMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.OctValue >
                                                                                        cartVariables.OctMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.OctValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.OctMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="mx-2">
                                                                        <small>November</small>
                                                                        <div v-if="!cartVariables.Nov">
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="form-control form-control-sm"
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div class="text-center position-relative" v-if="cartVariables.Nov > 1">
                                                                            <masked-input
                                                                                type="text"
                                                                                class="form-control form-control-sm"
                                                                                v-model="cartVariables.NovValue"
                                                                                :mask="currencyMask"
                                                                                @input="sumUp(x)"
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="cartVariables.NovValue"
                                                                                class="badge position-absolute"
                                                                                style="top:-5px;right:-5px;"
                                                                                :class="{
                                                                                    'bg-success': cartVariables.NovValue <= cartVariables.NovMax,
                                                                                    'bg-danger': cartVariables.NovValue > cartVariables.NovMax,
                                                                                }"
                                                                            >
                                                                                {{ cartVariables.NovValue }}/{{ cartVariables.NovMax}}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            mx-2
                                                                        "
                                                                    >
                                                                        <small
                                                                            >December</small
                                                                        >
                                                                        <div
                                                                            v-if="
                                                                                !cartVariables.Dec
                                                                            "
                                                                        >
                                                                            <input
                                                                                type="text"
                                                                                placeholder="N/A"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                disabled
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            class="
                                                                                text-center
                                                                                position-relative
                                                                            "
                                                                            v-if="
                                                                                cartVariables.Dec >
                                                                                1
                                                                            "
                                                                        >
                                                                            <masked-input
                                                                                type="text"
                                                                                class="
                                                                                    form-control
                                                                                    form-control-sm
                                                                                "
                                                                                v-model="
                                                                                    cartVariables.DecValue
                                                                                "
                                                                                :mask="
                                                                                    currencyMask
                                                                                "
                                                                                @input="
                                                                                    sumUp(
                                                                                        x
                                                                                    )
                                                                                "
                                                                            ></masked-input>
                                                                            <p
                                                                                v-if="
                                                                                    cartVariables.DecValue
                                                                                "
                                                                                class="
                                                                                    badge
                                                                                    position-absolute
                                                                                "
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -5px;
                                                                                "
                                                                                :class="{
                                                                                    'bg-success':
                                                                                        cartVariables.DecValue <=
                                                                                        cartVariables.DecMax,
                                                                                    'bg-danger':
                                                                                        cartVariables.DecValue >
                                                                                        cartVariables.DecMax,
                                                                                }"
                                                                            >
                                                                                {{
                                                                                    cartVariables.DecValue
                                                                                }}
                                                                                /
                                                                                {{
                                                                                    cartVariables.DecMax
                                                                                }}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="
                                                                    text-right
                                                                "
                                                            >
                                                                <button
                                                                    type="button"
                                                                    class="
                                                                        btn
                                                                        btn-success
                                                                        btn-sm
                                                                        me-2
                                                                    "
                                                                    @click="
                                                                        savePRItem(
                                                                            x
                                                                        )
                                                                    "
                                                                >
                                                                    Save
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-link btn-sm"
                                                                    @click="hidePopOver(x)"
                                                                    :ref="`po-${x.id}`"
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        </b-popover>
                                                    </td>
                                                    <td style="width: 150px">
                                                        {{
                                                            formatCurrency(
                                                                x.total
                                                            )
                                                        }}
                                                    </td>
                                                    <td style="width: 70px">
                                                        <a
                                                            href="javascript:void(0);"
                                                            class="action-icon text-primary"
                                                            v-if="!x.withChild"
                                                            @click="updateDescription(x, 'cancel')"
                                                        >
                                                            <i class="mdi mdi-content-save-edit-outline font-size-18"></i>
                                                        </a>
                                                        <a
                                                            href="javascript:void(0);"
                                                            class="action-icon text-danger"
                                                            v-if="!x.withChild"
                                                            @click="deleteCartItem(x, 'cancel')"
                                                        >
                                                            <i class="mdi mdi-trash-can font-size-18"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </template>
                                            <tr
                                                v-if="
                                                    filteredUpdateItems.length ==
                                                        0 &&
                                                    filterUpdateItems &&
                                                    !updateBusy
                                                "
                                            >
                                                <td
                                                    colspan="5"
                                                    class="text-center"
                                                >
                                                    Search not found
                                                </td>
                                            </tr>
                                            <tr
                                                v-if="
                                                    filteredUpdateItems.length ==
                                                        0 &&
                                                    !filterUpdateItems &&
                                                    !cartBusy
                                                "
                                            >
                                                <td
                                                    colspan="5"
                                                    class="text-center"
                                                >
                                                    No Items found
                                                </td>
                                            </tr>
                                            <tr v-if="updateBusy">
                                                <td
                                                    colspan="5"
                                                    class="text-center"
                                                >
                                                    <div
                                                        class="
                                                            d-flex
                                                            justify-content-center
                                                            align-items-center
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                preloader-component
                                                                me-2
                                                            "
                                                        >
                                                            <div class="status">
                                                                <div
                                                                    class="
                                                                        spinner-chase
                                                                        w-20px
                                                                        h-20px
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            chase-dot
                                                                        "
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <strong
                                                            >Loading...</strong
                                                        >
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="row mb-2">
                                    <div class="col mb-1 mt-4">
                                        <div
                                            class="
                                                dataTables_paginate
                                                paging_simple_numbers
                                                float-end
                                            "
                                        >
                                            <ul
                                                class="
                                                    pagination
                                                    pagination-rounded
                                                    mb-0
                                                "
                                            >
                                                <!-- pagination -->
                                                <b-pagination
                                                    v-model="currentPageUpdate"
                                                    :total-rows="
                                                        rowsUpdateItems
                                                    "
                                                    :per-page="perPageUpdate"
                                                ></b-pagination>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4">
                        <form @submit.prevent="savePR">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title mb-4">
                                        Purchase Request Details
                                    </h5>
                                    <div>
                                        <textarea
                                        rows="8"
                                        placeholder="Purchase Request Description"
                                        v-model="prHeader.description"
                                        class="form-control"
                                        :class="{
                                            'is-invalid':
                                                $v.prHeader.description.$error,
                                        }"
                                        >
                                        </textarea>
                                        <div
                                            v-if="$v.prHeader.description.$error"
                                            class="invalid-feedback"
                                        >
                                            <span
                                                v-if="
                                                    !$v.prHeader.description
                                                        .required
                                                "
                                                >This value is required.</span
                                            >
                                        </div>
                                    </div>
                                    <div class="mt-2">
                                        <label for="">End User Name</label>
                                        <b-input-group>
                                            <template
                                                #append
                                            >
                                                <b-button
                                                    @click="
                                                        selectUser('cancel');
                                                    "
                                                    variant="outline-info"
                                                    ><i
                                                        class="
                                                            mdi
                                                            mdi-clipboard-text-search-outline
                                                        "
                                                    ></i
                                                ></b-button>
                                            </template>
                                            <input
                                                type="text"
                                                placeholder="End User Name"
                                                class="form-control"
                                                v-model="prHeader.endUserName"
                                                :class="{
                                                    'is-invalid':
                                                        $v.prHeader.endUserName.$error,
                                                }"
                                                disabled
                                            />
                                        </b-input-group>
                                        <div
                                            v-if="$v.prHeader.endUserName.$error"
                                            class="invalid-feedback"
                                        >
                                            <span
                                                v-if="
                                                    !$v.prHeader.endUserName.required
                                                "
                                                >This value is required.</span
                                            >
                                        </div>
                                    </div>
                                    <div class="mt-2">
                                        <label for="">Delivery Location</label>
                                        <input
                                            type="text"
                                            placeholder="End User Name"
                                            class="form-control"
                                            v-model="prHeader.deliveryLocation"
                                            :class="{
                                                'is-invalid':
                                                    $v.prHeader.deliveryLocation.$error,
                                            }"
                                        />
                                        <div
                                            v-if="$v.prHeader.deliveryLocation.$error"
                                            class="invalid-feedback"
                                        >
                                            <span
                                                v-if="
                                                    !$v.prHeader.deliveryLocation.required
                                                "
                                                >This value is required.</span
                                            >
                                        </div>
                                    </div>
                                    <div class="mt-2">
                                        <label for="">Delivery Period</label>
                                        <b-input-group>
                                            <masked-input
                                                id="deliveryPeriod"
                                                type="text"
                                                v-model="prHeader.deliveryPeriod"
                                                placeholder="Enter Delivery Period..."
                                                class="form-control"
                                                :mask="currencyMask"
                                                autocomplete="off"
                                                :class="{
                                                    'is-invalid':
                                                        $v.prHeader.deliveryPeriod.$error,
                                                }"
                                            ></masked-input>
                                            <div class="input-group-append" style="width:calc(50% - 80px)">
                                                <span class="form-control">calendar day(s)</span>
                                            </div>
                                        </b-input-group>
                                        <div
                                            v-if="$v.prHeader.deliveryPeriod.$error"
                                            class="invalid-feedback"
                                        >
                                            <span
                                                v-if="
                                                    !$v.prHeader.deliveryPeriod.required
                                                "
                                                >This value is required.</span
                                            >
                                        </div>
                                    </div>
                                    <div class="mt-3" v-if="this.prHeader.id > 0">
                                        <button type="button" class="btn btn-outline-purple btn-block" @click="addAttachment"><i class="bx bx-paperclip"></i> Add Attachments ({{attachmentCount}})</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title mb-3">
                                        Purchase Request Summary
                                    </h4>
                                    <div
                                        class="table-responsive overflow-x-auto"
                                    >
                                        <table class="table mb-0">
                                            <tbody>
                                                <tr>
                                                    <td>Grand Total :</td>
                                                    <td>
                                                        {{
                                                            formatCurrency(
                                                                totalUpdateAmt()
                                                            )
                                                        }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Total :</th>
                                                    <th>
                                                        {{
                                                            formatCurrency(
                                                                totalUpdateAmt()
                                                            )
                                                        }}
                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <button
                                            type="submit"
                                            class="btn btn-success btn-block"
                                        >
                                            <i class="bx bx-save me-1"></i>
                                            Save & Update
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </b-tab>
        </b-tabs>
        <div class="position-fixed" style="bottom: 50px; right: 50px">
            <div
                class="position-relative"
                v-if="selectedAvailableItems.length > 0 && tabIndex == 0"
            >
                <button
                    class="
                        btn btn-success
                        d-flex
                        align-items-center
                        rounded-pill
                        hover-max-width
                    "
                    type="button"
                    @click="addToCart(selectedAvailableItems)"
                >
                    <i class="bx bx-cart font-size-18"></i
                    ><span>Add to Cart</span>
                </button>
                <small
                    class="position-absolute badge bg-danger"
                    style="top: -5px; right: -5px; z-index: 10px"
                    >{{ selectedAvailableItems.length }}</small
                >
            </div>
        </div>
        <print-options ref="printOpt"></print-options>
        <pr-logs ref="prLogs"></pr-logs>
        <employee-modal ref="empModal" @dropData="dropSingleEmployee"></employee-modal>
        <attachment-modal
            :wActions="true"
            title="Purchase Request Attachments"
            ref="attachmentModal"
            @dropCount="dropAttachmentCount"
        ></attachment-modal>
        <item-category @dropData="dropItemCat($event)"></item-category>
        <unit ref="unit" @dropData="dropUnit($event)"></unit>
        <ItemUpdate ref="itemUpdate" @dropData="updateDescriptionSubmit"/>
        <ConsolidatedItems 
            :tableData="consolidatedItems" 
            :loading="showConsolidatedItems"
            @remove-from-consolidation="removeFromConsolidation"
        />
    </Layout>
</template>